<template>
  <!--
      作者：gan
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline" style="flex-wrap: wrap">
        <el-form-item label="会员信息">
          <el-input v-model="searchForm.search" placeholder="真实姓名|手机号|身份证"></el-input>
        </el-form-item>
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no"
            placeholder="请输入订单号"></el-input></el-form-item>
        <el-form-item label="审核员"><el-input size="small" v-model="searchForm.remarks_operation"
            placeholder="请输入内容"></el-input></el-form-item>
        <el-form-item label="订单类型"><el-select size="small" v-model="searchForm.car_lease" placeholder="请选择订单类型">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in orderType" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select></el-form-item>
        <!-- <el-form-item label="配送方式">
          <el-select size="small" v-model="searchForm.style_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in exStyle" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="推广账号">
          <el-select size="small" v-model="searchForm.tuiguang_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in tglist" :key="index" :label="item.user_name"
              :value="item.shop_user_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.create_time" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search"
            @click="onSubmit">查询</el-button></el-form-item>
        <!-- <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item> -->
        <el-form-item><el-button size="small" type="info" @click="getshuax">刷新</el-button></el-form-item>
        <!-- <el-form-item v-if="activeName != 'haveInHand' && activeName != 'complete'">
          <template v-if="dxlist != ''">
            <el-button @click="godeleteall()" type="danger" size="small">删除</el-button>
          </template>
<template v-else>
            <el-button disabled type="danger" size="small">删除 </el-button>
          </template>
</el-form-item> -->
        <el-form-item>
          <template>
            <el-button @click="machineReview()" :disabled="dxlist === ''" type="primary" size="small">一键机审</el-button>
          </template>
        </el-form-item>
        <el-form-item><el-button size="small" type="success"
            @click.native="openTable('open')">一键开启菜单</el-button></el-form-item>

        <el-form-item>
          <el-button type="primary" size="small" @click.native="openTable('fold')">一键折叠菜单</el-button></el-form-item>

        <el-form-item>
          <el-button type="primary" size="small" style="width: 90px" @click="gofenpei('batch')">批分配客户</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="gofpMerchant('batch')">批分配商户</el-button>
        </el-form-item>
      </el-form>

      <!-- 机审分栏 -->
      <el-radio-group v-model="searchForm.auto_review" size="small" @input="onSubmit">
        <el-radio-button v-for="(item, index) in machineTabs" :label="item.name" :key="index">{{ item.label
          }}</el-radio-button>
      </el-radio-group>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <!-- <el-tab-pane :label="'未付款'" name="payment">
            <span slot="label">未付款 <el-tag size="mini">{{ order_count.payment }}</el-tag></span>
          </el-tab-pane> -->
          <el-tab-pane :label="'待审核'" name="examine">
            <span slot="label">待审核
              <el-tag size="mini">{{ order_count.examine }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'待发货'" name="delivery">
            <span slot="label">待发货
              <el-tag size="mini">{{ order_count.delivery }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'待收货'" name="received">
            <span slot="label">待收货
              <el-tag size="mini">{{ order_count.received }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'租赁中'" name="haveInHand">
            <span slot="label" @click="zulinz()">租赁中
              <el-tag size="mini">{{ order_count.haveInHand }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'待归还'" name="returned">
            <span slot="label">待归还
              <el-tag size="mini">{{ order_count.returned }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'归还中'" name="Returning">
            <span slot="label">归还中
              <el-tag size="mini">{{ order_count.Returning }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'拒归还'" name="refuse">
            <span slot="label">拒归还
              <el-tag size="mini">{{ order_count.refuse }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'取消中'" name="canceling">
            <span slot="label">取消中
              <el-tag size="mini">{{ order_count.canceling }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'已取消'" name="cancel">
            <span slot="label">已取消
              <el-tag size="mini">{{ order_count.cancel }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane label="已完成" name="complete">
            <span slot="label">已完成
              <el-tag size="mini">{{ order_count.complete }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'已驳回'" name="reject">
            <span slot="label">已驳回
              <el-tag size="mini">{{ order_count.reject }}</el-tag></span>
          </el-tab-pane>
          <!-- <el-tab-pane label="待评价" name="comment"></el-tab-pane> -->
          <!-- <el-tab-pane :label="'已买断'" name="BuyOut">
                <span slot="label">已买断 <el-tag size="mini">{{order_count.BuyOut}}</el-tag></span>
              </el-tab-pane> -->
        </el-tabs>
        <!-- <el-table size="small" :data="tableData.data" :span-method="arraySpanMethod" border style="width: 100%"
          v-loading="loading" @selection-change="handleSelectionChange"> -->
        <el-table size="small" :data="tableData.data" border class="table" style="width: 100%" v-loading="loading"
          @selection-change="handleSelectionChange" default-expand-all ref="table" row-key="order_id">
          <el-table-column type="selection" width="40" style="min-width: 100px">
          </el-table-column>
          <el-table-column type="expand" prop="create_time" width="0">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="control">
                <div>
                  重复下单:
                  <span style="color: red">
                    {{ scope.row.usernum ? scope.row.oldcount : "null" }} 单
                  </span>
                </div>
                <div style="color: red; font-weight: 500">
                  <span v-html="scope.row.remarks_risk"> </span>
                </div>
                <div style="color: red; font-weight: 500">
                  上次风控备注:{{ scope.row.old_beizhu }}
                </div>
                <div v-if="scope.row.supplier">
                  商户来源:{{ scope.row.supplier.name }}
                </div>
                <div style="display: flex" v-if="scope.row.tuiguangname">
                  推广来源:
                  <span>{{ scope.row.tuiguangname }}</span>
                </div>
                <div style="display: flex">
                  审核员:
                  <span>{{
                    scope.row.admin_name == "" ? "无" : scope.row.admin_name
                    }}</span>
                </div>
              </div>
              <div class="control">
                <div @click="czbztk(scope.row)" style="color: #dd1144; text-align: center; cursor: pointer">
                  订单备注：
                  {{
                    scope.row.remarks_operation
                      ? scope.row.remarks_operation
                      : "Empty"
                  }}
                </div>
                <div>下单时间:{{ scope.row.create_time }}</div>
                <div v-if="scope.row.examine_time != 0" style="color: red">
                  通过时间:{{ scope.row.examine_time | formatDate }}
                </div>
                <div>到期时间:{{ scope.row.duedate }}</div>
              </div>
              <div class="control">
                <div>
                  快递公司：:
                  <span class="juz">
                    {{
                      scope.row.express_id
                        ? scope.row.express_id
                        : "暂无" | delivery
                    }}
                  </span>
                </div>
                <div>
                  快递单号：<span class="juz">
                    {{ scope.row.express_no ? scope.row.express_no : "暂无" }}
                  </span>
                </div>
                <div>
                  设备号:
                  <span class="juz">
                    {{ scope.row.jindun_num ? scope.row.jindun_num : "暂无" }}
                  </span>
                </div>
              </div>
              <div class="control">
                <div>
                  认证信息:
                  <span class="juz">
                    {{ scope.row.user.nickName }}({{
                      scope.row.usernum ? scope.row.usernum : ""
                    }})</span>
                </div>
                <div>
                  | 性别:<span class="juz">
                    {{ scope.row.user.gender == 1 ? "男" : "女" }}</span>
                </div>
                <div>
                  | 年龄:<span class="juz">
                    {{ scope.row.usernum | getsfz }}</span>
                </div>
                <div>| 蚁盾分:<span class="juz"> 35 </span></div>
                <div>| 基础资料:<span class="juz"> 已上传 </span></div>
                <div>| 审核资料:<span class="juz"> 已上传 </span></div>
                <div>
                  | 签署合同:<span class="juz" v-if="scope.row.folwid !== ''">
                    {{ scope.row.is_user == "2" ? "已签署" : "未签署" }}
                  </span>
                  <span v-else>
                    未发起签署流程
                  </span>
                </div>
                <div>
                  | 是否上链:<span class="juz">
                    {{ scope.row.sign_str_status == "SIGNED" ? "是" : "否" }}
                  </span>
                </div>
                <div>| 绑定银行卡:<span class="juz"> 是 </span></div>
                <div>
                  | 征信授权状态:<span class="juz">
                    {{ scope.row.huacan_status == 1 ? "已授权" : "未授权" }}
                  </span>
                </div>
                <div>
                  | 大订单签署状态:<span class="juz">
                    {{ scope.row.alipayBigOrder != null && scope.row.alipayBigOrder.status != 'CREATED'  ? "已授权" : "未授权" }}
                  </span>
                </div>
              </div>
              <div class="control">
                <div>
                  风控分数：<span class="juz">
                    {{ scope.row.credit_report }} ({{
                      scope.row.cancel_remark
                    }})</span>
                </div>
                <div>
                  欺诈分: <span class="juz"> {{ scope.row.ant_shield }} </span>
                </div>
                <div>
                  驳回原因: <span class="juz2">{{ scope.row.tips }}</span>
                </div>
                <div>
                  取消原因：
                  <span class="juz2">
                    {{ scope.row.reason ? scope.row.reason : "" }}
                  </span>
                </div>
                <div>
                  上次驳回原因:
                  <span class="juz3">
                    {{ scope.row.usernum ? scope.row.old_desc : "" }}
                  </span>
                </div>
              </div>
              <div class="control">
                <div>
                  <el-button v-if="scope.row.order_status.value == 1" size="mini" type="primary"
                    @click="showShenhe(scope.row)">通过</el-button>
                </div>
                <div v-if="!scope.row.shop_url">
                  <el-button v-if="scope.row.order_id <= 850" @click="goaiqian(scope.row)" type="success"
                    size="mini">生成合同
                  </el-button>
                  <el-button v-if="
                    scope.row.order_id > 850 &&
                    scope.row.alipayBigOrder != null &&
                    scope.row.alipayBigOrder.status != 'CREATE'
                  " @click="goaiqian(scope.row)" type="success" size="mini">生成合同
                  </el-button>
                </div>
                <div v-else>
                  <el-button @click="gockaq(scope.row.shop_url)" type="success" size="mini">查看合同
                  </el-button>
                </div>
                <div v-if="scope.row.shop_url">
                  <el-button @click="xiazai(scope.row.shop_url)" type="success" size="mini">下载合同
                  </el-button>
                </div>
                <div>
                  <el-button v-if="scope.row.apply_Status == ''" @click="getProve(scope.row)" type="success"
                    size="mini">赋强公证</el-button>
                  <el-button v-else disabled type="success" size="mini">赋强公证</el-button>
                </div>
                <div>
                  <el-button @click="addClick(scope.row)" type="primary" size="mini"
                    v-auth="'/order/order/detail'">订单详情</el-button>
                </div>
                <div v-if="
                  scope.row.delivery_type.value == 10 &&
                  scope.row.delivery_status.value == 20
                ">
                  <el-button @click="getLogistics(scope.row)" type="primary" size="mini">查看物流</el-button>
                </div>
                <div>
                  <el-button v-if="
                    scope.row.delivery_status.value == 10 &&
                    scope.row.order_id <= 850
                  " @click="gofahuo(scope.row)" type="primary" size="mini">订单发货</el-button>
                  <el-button v-if="
                    scope.row.order_id > 850 &&
                    scope.row.alipayBigOrder != null &&
                    scope.row.alipayBigOrder.status != 'CREATED' &&
                    scope.row.delivery_status.value == 10
                  " @click="gofahuo(scope.row)" type="primary" size="mini">订单发货</el-button>
                </div>
                <div v-if="
                  scope.row.delivery_status.value == 20
                ">
                  <el-button @click="goque(scope.row)" type="primary" size="mini">确定收货</el-button>
                </div>
                <!-- <div>
                  <el-button @click="snapshot(scope.row)" type="primary" size="mini">回执单</el-button>
                </div> -->
                <div>
                  <el-button size="mini" @click="logisticsSnp(scope.row)">物流回执单</el-button>
                </div>
                <div v-if="scope.row.mianyaRefund == '1'">
                  <el-button size="mini" @click="handleMianyaRefund(scope.row)">免押退款处理</el-button>
                </div>
                <div v-if="scope.row.order_id <= 850">
                  <el-button type="primary" size="mini" @click="auditDeduction(scope.row)"
                    v-if="scope.row.sign_validate == 0">审核代扣签约</el-button>
                  <el-button @click="noDeduction(scope.row)" type="primary" size="mini" v-if="
                    scope.row.sign_validate == 1 &&
                    scope.row.sign_str_status == 'SIGNED'
                  ">代扣解约</el-button>
                </div>
                <div v-if="
                  scope.row.sign_validate == 1 &&
                  scope.row.sign_str_status == 'APPLY_TERMINATE'
                ">
                  <el-button type="primary" size="mini" @click="Terminate(scope.row, 1)">同意解约</el-button>
                  <el-button type="primary" size="mini" @click="Terminate(scope.row, 0)">拒绝解约</el-button>
                </div>
                <div class="anniu1" v-if="scope.row.order_id <= 850">
                  <el-button @click="gojiedong(scope.row)" type="primary" size="mini">资金解冻-预授权</el-button>
                </div>
                <div class="anniu1" v-if="scope.row.order_id <= 850">
                  <el-button @click="goyajin(scope.row)" type="primary" size="mini">预授权资金转租金</el-button>
                </div>
                <div style="margin-left:10px">
                  <supervise-lock :item="scope.row" />
                </div>
                <!--<div class="anniu1">
                  <el-button @click="shangbao(scope.row)" type="primary" size="mini">上报征信</el-button>
                </div>-->
                <div class="anniu1" v-if="scope.row.order_status.text == '已归还'">
                  <el-button @click="guihuan(scope.row)" type="warning" size="mini">同意归还</el-button>
                </div>
                <div class="button-style2 d-c-c" style="margin-bottom: 20px;" v-if="scope.row.order_status.value == 50">
                  <el-button @click="submitConfirm(scope.row)" size="mini" type="primary">
                    同意取消
                  </el-button>
                </div>
                <div class="anniu1" v-if="scope.row.order_status.text == '已归还'">
                  <el-button @click="guihuan2(scope.row)" type="danger" size="mini">拒绝归还</el-button>
                </div>
                <!-- <AntWithHold :item="scope.row" /> -->
                <!-- <eqbContract :item="scope.row" @closeEqb="closeEqb" /> -->

                <!-- <WeiPai :item="scope.row" /> -->
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="ID" width="60">
            <template slot-scope="scope">
              <div
                class="gray9"
                style="height: 500px; display: flex; align-items: center"
              >
                {{ scope.row.order_id }}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column label="图片" width="60">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                ">
                <img style="width: 65px; height: 65px" :src="scope.row.product[0].image.file_path" />
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="user_id" label="订单信息" width="290">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center">
                <div class="product-info" v-for="(item, index) in scope.row.product" :key="index">
                  <div class="disf">
                    <div v-if="
                      item.product_attr.indexOf('不') != -1 &&
                      item.product_attr.indexOf('保障服务')
                    "></div>
                    <div v-else>
                      <span v-if="item.product_attr.indexOf('保障服务') != -1" class="bzfw">已投碎屏险保障</span>
                    </div>
                    <div v-if="scope.row.car_lease" class="carBox">
                      以租代购
                    </div>
                    <div class="c_main">订单号：{{ scope.row.order_no }}</div>
                    <div class="name gray3 product-name">
                      <span>{{ item.product_name }}</span>
                    </div>
                    <div class="gray9" v-if="item.product_attr">
                      {{ item.product_attr }}
                    </div>

                    <div class="leasetype">{{ scope.row.lease_type }}</div>

                    <div class="orange" v-if="item.refund">
                      {{ item.refund.type.text }}-{{ item.refund.status.text }}
                    </div>
                    <div>
                      数量: <span class="juz"> x {{ item.total_num }} </span>
                    </div>
                    <!-- <div>
                      重复下单:
                      <span style="color: red">
                        {{ scope.row.usernum ? scope.row.oldcount : "null" }} 单
                      </span>
                    </div>
                    <div style="color: red; font-weight: 500">
                      <span v-html="scope.row.remarks_risk"> </span>
                    </div>
                    <div style="color: red; font-weight: 500">
                      上次风控备注:{{ scope.row.old_beizhu }}
                    </div>
                    <div v-if="scope.row.supplier">
                      商户来源:{{ scope.row.supplier.name }}
                    </div>
                    <div style="display: flex">
                      推广来源:
                      <span v-for="item5 in tglist" :key="item5.shop_user_id"
                        >{{
                          item5.shop_user_id == scope.row.tuiguangid
                            ? item5.real_name
                            : ""
                        }}
                      </span>
                    </div> -->
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="pay_price" label="付款信息" width="180">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span style="color: #3498db">
                总租金:<span class="fontwb">￥{{
                  scope.row.total_price ? scope.row.total_price : ""
                }}</span>
              </span>
              <p class="">
                买断价:<span class="fontwb">￥{{ scope.row.new_buy_out_price }}</span>
              </p>
              <p class="">
                优惠:<span class="fontwb">￥{{ scope.row.coupon_money }}</span>
              </p>
              <p class="">
                已还租:<span style="color: #3498db">￥{{ scope.row.pricezq }}</span>
              </p>
              <!-- <p class="">
                预授权+预交租金:<span class="fontwb"
                  >￥{{ scope.row.yujyj }}</span
                >
              </p>
              <div class="">
                预交租金:<span class="fontwb">￥{{ scope.row.yushou }}</span>
              </div>
              <div class="">
                预授权押金总额:<span class="fontwb"
                  >￥{{ scope.row.ysqyjze }}</span
                >
              </div>
              <div class="">
                信用免押:<span style="color: red">￥0.00</span>
              </div> -->
              <!-- <div class="orange">预授权转租金总额:￥{{ scope.row.zhuanzujin }}</div> -->
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="预交租金" width="180">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <p class="">
                预授权+预交租金:<span class="fontwb">￥{{ scope.row.yujyj }}</span>
              </p>
              <div class="">
                预交租金:<span class="fontwb">￥{{ scope.row.yushou }}</span>
              </div>
              <div class="">
                预授权押金总额:<span class="fontwb">￥{{ scope.row.ysqyjze }}</span>
              </div>
              <div class="">
                信用免押:<span style="color: red">￥0.00</span>
              </div>
              <!-- <div class="orange">预授权转租金总额:￥{{ scope.row.zhuanzujin }}</div> -->
            </template>
          </el-table-column>
          <!-- <el-table-column prop="yushou" label="预收租金">
                <template slot-scope="scope">
                </template>
              </el-table-column> -->
          <el-table-column prop="" label="买家" width="280">
            <template slot-scope="scope" v-if="!scope.row.is_top_row && scope.row.user">
              <div class="fwbold">
                <div class="xxflex">
                  租户姓名：
                  <span class="usercolor">
                    {{ scope.row.username ? scope.row.username : "null" }}
                  </span>
                  / 年龄：
                  <span class="usercolor" v-if="scope.row.usernum">{{ scope.row.usernum | getsfz }}
                  </span>
                  <span class="usercolor" v-else> null </span>
                </div>
                <div>租户昵称：{{ scope.row.user.nickName }}</div>
                <div>
                  身份证号：{{
                    scope.row.usernum ? scope.row.usernum : ""
                  }}
                  (<span v-if="scope.row.hasrenzheng == 1">已认证</span>
                  <span v-else style="color: #ff1e10; font-weight: bold; font-size: 14px">未认证</span>)
                </div>
                <div>
                  手机号：{{
                    scope.row.user.mobile ? scope.row.user.mobile : ""
                  }}
                </div>
                <!-- <div>
                  收货地址:
                  <span>{{ scope.row.address.region.province }}</span>
                  <span>{{ scope.row.address.region.city }}</span>
                  <span>{{ scope.row.address.region.region }}</span>
                  <span>{{ scope.row.address.detail }}</span>
                </div>
                <div>下单IP:{{ scope.row.ip }}</div>
                <div>
                  下单地区:{{ scope.row.province }} {{ scope.row.city }}
                  {{ scope.row.district }}
                </div> -->
                <!-- <div>号码归属地:</div> -->
              </div>
              <!-- <div>
                风控分数：<span class="juz">
                  {{ scope.row.credit_report }} ({{
                    scope.row.cancel_remark
                  }})</span
                >
                <br />
                欺诈分: <span class="juz"> {{ scope.row.ant_shield }} </span>
              </div>
              <div>
                驳回原因: <span class="juz2">{{ scope.row.tips }}</span>
              </div>
              <div>
                取消原因：
                <span class="juz2">
                  {{ scope.row.reason ? scope.row.reason : "" }}
                </span>
              </div>
              <div>
                上次驳回原因:
                <span class="juz3">
                  {{ scope.row.usernum ? scope.row.old_desc : "" }}
                </span>
              </div> -->
            </template>
          </el-table-column>
          <!-- <el-table-column prop="supplier.name" label="商户名称"></el-table-column> -->

          <!-- <el-table-column prop="remarks_operation" label="备注">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div
                @click="czbztk(scope.row)"
                style="color: #dd1144; text-align: center; cursor: pointer"
              >
                {{
                  scope.row.remarks_operation
                    ? scope.row.remarks_operation
                    : "Empty"
                }}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="state_text" label="交易状态" width="100">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                ">
                <div class="dotg"></div>
                <div style="color: #18bc9c; margin-left: 3px">
                  {{
                    scope.row.order_status.value == 40
                      ? "已驳回"
                      : scope.row.state_text
                  }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="state_text" label="用户地址" width="220">
            <template slot-scope="scope" v-if="!scope.row.is_top_row && scope.row.user">
              <div v-if="scope.row.address">
                收货地址:
                <span>{{ scope.row.address.region.province }}</span>
                <span>{{ scope.row.address.region.city }}</span>
                <span>{{ scope.row.address.region.region }}</span>
                <span>{{ scope.row.address.detail }}</span>
              </div>
              <div>下单IP:{{ scope.row.ip }}</div>
              <div>
                下单地区:{{ scope.row.province }} {{ scope.row.city }}
                {{ scope.row.district }} {{ scope.row.address_detail }}
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="create_time" label="下单时间" width="190">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>下单时间:{{ scope.row.create_time }}</div>
              <div v-if="scope.row.examine_time != 0" style="color: red">
                通过时间:{{ scope.row.examine_time | formatDate }}
              </div>
            </template>
          </el-table-column> -->

          <!-- <el-table-column prop="remarks_risk" label="风控备注">
              <template slot-scope="scope" v-if="!scope.row.is_top_row">
                <div @click="fzbztk(scope.row)" style="color:#DD1144">{{
                  scope.row.remarks_risk ? scope.row.remarks_risk : "暂无"
                }}</div>
              </template>
            </el-table-column> -->
          <!-- <el-table-column prop="pay_type.text" label="支付方式" width="100">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="gray9">{{ scope.row.pay_type.value == 20 ? '支付宝支付' : '' }}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="delivery_type.text" label="配送方式" width="70">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="green">{{ scope.row.delivery_type.text }}</span>
              <span v-if="scope.row.delivery_type.value == 30">手机号:{{ scope.row.user.mobile }}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="is_comment" label="评价" width="60">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span v-if="scope.row.is_comment == 0">未评价</span>
              <span v-else="">已评价</span>
            </template>
          </el-table-column> -->

          <el-table-column prop="is_comment" label="退款状态" width="110">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>
                <span>{{ scope.row.tuikuanzhauntai }}</span>
                <div v-if="scope.row.tuikuanzhauntai == '失败'">
                  <span>
                    <span class="green">预收错误：</span>
                    {{
                      scope.row.ys_fail_msg ? scope.row.ys_fail_msg : "无"
                    }}</span>
                  <br />
                  <span>
                    <span class="green">押金错误：</span>{{
                      scope.row.yj_fail_msg ? scope.row.yj_fail_msg : "无"
                    }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="120">
            <!-- fixed="right"-->
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="czbutton">
                <!-- <div>
                  <el-button
                    v-if="scope.row.order_status.value == 1"
                    size="small"
                    type="primary"
                    @click="showShenhe(scope.row)"
                    >通过</el-button
                  >
                </div> -->
                <div>
                  <!--
                   -->
                  <el-button v-if="
                    scope.row.state_text == '待审核' ||
                    scope.row.state_text == '待发货' ||
                    scope.row.state_text == '待收货'
                  " style="width: 90px" size="mini" type="danger" @click="showShenhe2(scope.row)">驳回</el-button>
                  <!--  -->
                  <el-button v-else-if="scope.row.order_status.value == '50'" size="mini" type="primary"
                    @click="confirmCancel(scope.row)">审核用户取消</el-button>
                </div>
                <div class="anniu1">
                  <el-button @click="gofengkong(scope.row)" type="primary" style="width: 90px"
                    size="mini">风控备注</el-button>
                </div>
                <div>
                  <el-button @click="gofenpei(scope.row)" type="primary" size="mini"
                    style="width: 90px">分配客户</el-button>
                </div>
                <div>
                  <el-button @click="gofpMerchant(scope.row)" type="warning" size="mini"
                    style="width: 90px">分配商户</el-button>
                </div>
                <!-- <div>
                  <el-button @click="gomayi(scope.row)" type="success" size="small">生成合同</el-button>
                </div> -->
                <!-- <div v-if="!scope.row.aiqianhetong">
                  <el-button
                    @click="goaiqian(scope.row)"
                    type="success"
                    size="small"
                    >生成合同
                  </el-button>
                </div>
                <div v-else>
                  <el-button
                    @click="gockaq(scope.row.aiqianhetong)"
                    type="success"
                    size="small"
                    >查看合同
                  </el-button>
                </div> -->
                <!-- <div v-if="scope.row.zlht">
                  <el-button
                    @click="xiazaiht(scope.row.zlht)"
                    type="success"
                    size="small"
                    >下载合同
                  </el-button>
                </div> -->
                <!-- <el-button
                  v-if="scope.row.apply_Status == ''"
                  @click="getProve(scope.row)"
                  type="success"
                  size="small"
                  >赋强公证</el-button
                >
                <el-button v-else disabled type="success" size="small"
                  >赋强公证</el-button
                > -->
                <!-- <div>
                  <el-button
                    @click="addClick(scope.row)"
                    type="info"
                    size="small"
                    v-auth="'/order/order/detail'"
                    >订单详情</el-button
                  >
                </div> -->
                <!-- <div>
                  <el-button @click="submission(scope.row)" v-if="scope.row.order_status.text == '进行中'" type="success"
                    size="small">申请上报</el-button>
                </div> -->
                <!-- <div>
                  <el-button @click="Loan(scope.row)" v-if="scope.row.order_status.text == '进行中'" type="success"
                    size="small">放款报送</el-button>
                </div> -->
                <div>
                  <el-button @click="goeditsp(scope.row)" type="danger" v-if="scope.row.order_status.text == '待审核'"
                    size="mini" style="width: 90px">修改商品</el-button>
                </div>
                <div>
                  <el-button @click="openEditIssue(scope.row)" type="warning" v-if="
                    scope.row.pay_status.value == 10 &&
                    scope.row.alipayBigOrder == null
                  " size="mini" style="width: 90px">修改首期</el-button>
                </div>
                <div v-if="scope.row.order_id <= 850">
                  <el-button @click="viewOrderStatus(scope.row)" type="primary" size="mini">查询订单状态</el-button>
                </div>
                <div v-if="scope.row.receipt_status.value == 10 && scope.row.order_status.value == 10">
                  <el-button
                    @click="goque(scope.row)"
                    type="primary"
                    size="small"
                    >确认收货</el-button
                  >
                </div>
                <div>
                  <el-button @click="goyujiao(scope.row)" v-if="scope.row.order_id <= 850" type="primary" size="mini"
                    style="width: 90px">预交租金</el-button>
                </div>
                <!-- <div>
                  <el-button
                    v-if="
                      scope.row.delivery_type.value == 10 &&
                      scope.row.delivery_status.value == 20
                    "
                    @click="getLogistics(scope.row)"
                    type="primary"
                    size="small"
                    >查看物流</el-button
                  >
                </div>
                <div>
                  <el-button
                    v-if="scope.row.delivery_status.value == 10"
                    @click="gofahuo(scope.row)"
                    type="primary"
                    size="small"
                    >订单发货</el-button
                  >
                </div>
                <div>
                  <el-button
                    v-if="
                      scope.row.delivery_type.value == 10 &&
                      scope.row.delivery_status.value == 20
                    "
                    @click="goque(scope.row)"
                    type="primary"
                    size="small"
                    >确定收货</el-button
                  >
                </div>
                <div>
                  <el-button
                    @click="snapshot(scope.row)"
                    type="primary"
                    size="small"
                    >回执单</el-button
                  >
                </div> -->
                <div>
                  <el-button @click="addBlack(scope.row)" type="danger" size="mini"
                    style="width: 90px">加入黑名单</el-button>
                </div>
                <div v-if="
                  scope.row.delivery_type.value == 10 &&
                  scope.row.order_status.text == '进行中'
                ">
                  <el-button v-if="scope.row.order_id <= 850" @click="gotyj(scope.row)" type="danger" size="mini"
                    style="width: 90px">驳回退押金</el-button>
                </div>
                <div>
                  <el-button type="warning" size="mini" style="width: 90px" v-if="is_zgzl"
                    @click="getQRPayDetail(scope.row)">
                    扫码支付
                  </el-button>
                </div>
                <div>
                  <!--   -->
                  <el-button @click="wancheng(scope.row)" v-if="
                    scope.row.order_status.text == '进行中' &&
                    scope.row.order_id <= 850
                  " type="danger" size="mini" style="width: 90px">完成订单</el-button>
                </div>
                <!-- <div class="anniu1">
                  <el-button
                    @click="gojiedong(scope.row)"
                    type="primary"
                    size="small"
                    >资金解冻-预授权</el-button
                  >
                </div>
                <div class="anniu1">
                  <el-button
                    @click="goyajin(scope.row)"
                    type="primary"
                    size="small"
                    >预授权资金转租金</el-button
                  >
                </div> -->
                <!-- <div class="anniu">
                <el-button @click="goqianshu(scope.row)" type="success" size="small">查看合同</el-button>
              </div> -->
                <!-- <div>
                <el-button @click="goheton(scope.row)" type="success" size="small">生成合同</el-button>
              </div> -->
                <!-- <div>
                <el-button @click="godelete(scope.row)" type="danger" size="small">删除订单</el-button>
              </div> -->
              </div>
              <!-- <el-dropdown
                split-button
                type="primary"
                v-if="scope.row.order_status.text == '进行中'"
              >
                更多菜单
                <el-dropdown-menu slot="dropdown">
                  <div class="anniu1">
                    <el-button
                      @click="kaihu(scope.row)"
                      v-if="scope.row.order_status.text == '进行中'"
                      type="danger"
                      size="small"
                      >开户</el-button
                    >
                  </div>
                  <div class="anniu1">
                    <el-button
                      @click="wancheng(scope.row)"
                      v-if="scope.row.order_status.text == '进行中'"
                      type="danger"
                      size="small"
                      >完成</el-button
                    >
                  </div>
                  <div class="anniu1">
                    <el-button
                      @click="Upwqzm(scope.row)"
                      v-if="scope.row.order_status.text == '进行中'"
                      type="warning"
                      size="small"
                      >物权证明</el-button
                    >
                  </div>
                  <div class="anniu1">
                    <el-button
                      @click="Updxcjjt(scope.row)"
                      v-if="scope.row.order_status.text == '进行中'"
                      type="warning"
                      size="small"
                      >短信催缴截图</el-button
                    >
                  </div>
                  <div class="anniu1">
                    <el-button
                      @click="Uploadpdf(scope.row, '1')"
                      v-if="scope.row.order_status.text == '进行中'"
                      type="info"
                      size="small"
                      >上传代偿证明</el-button
                    >
                  </div>
                  <div class="anniu1">
                    <el-button
                      @click="Uploadpdf(scope.row, '2')"
                      v-if="scope.row.order_status.text == '进行中'"
                      type="info"
                      size="small"
                      >上传代偿通知书</el-button
                    >
                  </div>
                  <div class="anniu1">
                    <el-button
                      @click="Uploadhzd(scope.row)"
                      v-if="scope.row.order_status.text == '进行中'"
                      type="info"
                      size="small"
                      >上传收货回执单</el-button
                    >
                  </div>

                  <div class="anniu1">
                    <el-button
                      @click="Upzl(scope.row)"
                      v-if="scope.row.order_status.text == '进行中'"
                      type="warning"
                      size="small"
                      >资料上传</el-button
                    >
                  </div>

                  <div class="anniu1">
                    <el-button @click="Upyqzl(scope.row)" v-if="scope.row.order_status.text == '进行中'" type="warning"
                      size="small">逾期资料上传</el-button>
                  </div>
                </el-dropdown-menu>
              </el-dropdown> -->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 上传收货回执单 -->
      <el-dialog title="上传收货回执单" :visible.sync="dialogVisibleHZD" width="60%">
        <div>
          <el-button @click="chooseImg('schzd', 'schzd')">选择图片</el-button>
          <img class="mt10" v-img-url="schzd" width="200" />
          <div style="margin-top: 10px">
            <el-button @click="qrUploadhzd()">确 定</el-button>
            <el-button @click="dialogVisibleHZD = false">取 消</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 上传短信催缴截图 -->
      <el-dialog title="上传短信催缴截图" :visible.sync="dialogVisibleDXCJ" width="60%">
        <div>
          <el-button @click="chooseImg('dxcj', 'dxcj')">选择图片</el-button>
          <img class="mt10" v-img-url="dxcj" width="200" />
          <div style="margin-top: 10px">
            <el-button @click="qrUploaddxck()">确 定</el-button>
            <el-button @click="dialogVisibleDXCJ = false">取 消</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 上传物权证明 -->
      <el-dialog title="上传物权证明 " :visible.sync="dialogVisibleWQZM" width="60%">
        <div>
          <el-button @click="chooseImg('wqzm', 'wqzm')">选择图片</el-button>
          <img class="mt10" v-img-url="wqzm" width="200" />
          <div style="margin-top: 10px">
            <el-button @click="qrUploadwqzm()">确 定</el-button>
            <el-button @click="dialogVisibleWQZM = false">取 消</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 上传资料选择类型 -->
      <el-dialog title="上传 " :visible.sync="dialogVisibleupzl" width="60%">
        <div>
          <el-select v-model="zltype" placeholder="请选择类型">
            <el-option :label="item.type" v-for="(item, index) in fkList" :key="index" :value="item.value"></el-option>
          </el-select>
          <div style="margin-top: 10px">
            <el-button @click="qrUpzl()">确 定</el-button>
            <el-button @click="dialogVisibleupzl = false">取 消</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 结清弹窗 -->
      <el-dialog title="结清" :visible.sync="dialogVisiblejq" width="60%">
        <div>
          <el-form size="small" ref="jqform" :model="form" label-width="100px">
            <el-form-item label="金额(元)">
              <el-input v-model="jqform.value" class="max-w460"></el-input>
            </el-form-item>
            <el-form-item label="类型">
              <el-select v-model="jqform.type" placeholder="请选择类型">
                <el-option :label="item.type" v-for="(item, index) in jieqingList" :key="index"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div style="margin-top: 10px">
            <el-button @click="orderjq()">确 定</el-button>
            <el-button @click="dialogVisiblejq = false">取 消</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 完成弹窗 -->
      <el-dialog title="完成" :visible.sync="dialogVisiblewc" width="60%">
        <div>
          <div style="margin-top: 10px">
            <div>
              <el-input v-model="wanchengPassword" type="password" placeholder="请输入密码" />
            </div>
            <div style="
                margin: 20px 30px;
                border-radius: 20px;
                font-size: 25px;
                color: red;
                background-color: #e1e1e1;
                text-align: center;
                padding: 15px;
              ">
              是否要进行完成操作!!!
            </div>
            <el-button @click="dialogVisiblewc = false">取 消</el-button>
            <el-button @click="orderwc()">确 定</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 修改商品弹框 -->
      <!-- <el-dialog
        title="修改商品"
        :visible.sync="dialogVisiblexgsp"
        width="70%"
        @close="closexg"
      >
        <div style="padding: 20px">
          <div
            style="
              margin: 20px 30px;
              border-radius: 20px;
              font-size: 25px;
              color: red;
              background-color: #e1e1e1;
              text-align: center;
              padding: 15px;
            "
          >
            如果需要修改订单商品信息，请务必与客户沟通好后进行修改，切记不可私自修改!每次修改都会详细记录!
          </div>

          <div
            style="
              margin: 20px 30px;
              border-radius: 20px;
              font-size: 25px;
              color: #2f96db;
              background-color: #e1e1e1;
              text-align: center;
              padding: 15px;
            "
          >
            收货人： {{ shr }} <br />
            电话： {{ shrdh }} <br />
            原商品名称: {{ prData.product_name }} <br />
            原商品规格：{{ prData.product_attr }} <br />
          </div>

          <div style="display: flex">
            <div style="display: flex; flex-direction: column">
              <div class="mr">
                商品分类：
                <el-select
                  v-model="spflvalue"
                  placeholder="请选择"
                  @change="selectSP($event)"
                >
                  <el-option
                    v-for="item in catList"
                    :key="item.category_id"
                    :label="item.name"
                    :value="item.category_id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="mr">
                品牌分类：
                <el-select
                  v-model="sxspvalue"
                  placeholder="请选择"
                  @change="selectSP2($event)"
                >
                  <el-option
                    v-for="(item, index) in catList2"
                    :key="index"
                    :label="item.name"
                    :value="item.category_id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="mr">
                商品名称：
                <el-select
                  v-model="sxggvalue"
                  placeholder="请选择"
                  @change="selectSP3($event)"
                  size="100%"
                >
                  <el-option
                    v-for="item in catList3"
                    :key="item.product_id"
                    :label="item.product_name"
                    :value="item.product_id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="mr2">
                <span class="qianshu">市场价</span>:<el-input
                  style="width: 50%; margin-left: 10px"
                  v-model="shouji_price"
                  placeholder="请输入价格"
                ></el-input>
              </div>
              <div class="mr2">
                <span class="qianshu">收益率</span>:<el-input
                  v-model="rate"
                  style="width: 50%; margin-left: 10px"
                  placeholder="请输入利率"
                ></el-input>
                %
              </div>
              <div class="mr2">
                <span class="qianshu">灵活收款</span>:<el-input
                  v-model="linghuo_price"
                  style="width: 50%; margin-left: 10px"
                  placeholder="请输入"
                ></el-input>
              </div>
              <el-button type="warning" style="width: 150px" @click="Preview()"
                >预览账单</el-button
              >
            </div>

            <div style="display: flex; flex-direction: column">
              <div class="mr" v-if="catList5.length >= 1">
                {{ catList5[0].group_name }} :
                <el-radio-group
                  v-model="Attrvalue"
                  @change="selectSP5($event, catList5[0].group_name, 0)"
                >
                  <el-radio
                    v-for="item in catList5[0].spec_items"
                    :key="item.item_id"
                    :label="item.item_id"
                    :value="item.spec_value"
                    >{{ item.spec_value }}</el-radio
                  >
                </el-radio-group>
              </div>
              <div class="mr" v-if="catList5.length >= 2">
                {{ catList5[1].group_name }} :
                <el-radio-group
                  v-model="Attrvalue2"
                  @change="selectSP5($event, catList5[1].group_name, 1)"
                >
                  <el-radio
                    v-for="item in catList5[1].spec_items"
                    :key="item.item_id"
                    :label="item.item_id"
                    :value="item.spec_value"
                    >{{ item.spec_value }}</el-radio
                  >
                </el-radio-group>
              </div>
              <div class="mr" v-if="catList5.length >= 3">
                {{ catList5[2].group_name }} :
                <el-radio-group
                  v-model="Attrvalue3"
                  @change="selectSP5($event, catList5[2].group_name, 2)"
                >
                  <el-radio
                    v-for="item in catList5[2].spec_items"
                    :key="item.item_id"
                    :label="item.item_id"
                    :value="item.spec_value"
                    >{{ item.spec_value }}</el-radio
                  >
                </el-radio-group>
              </div>
              <div class="mr" v-if="catList5.length >= 4">
                {{ catList5[3].group_name }} :
                <el-radio-group
                  v-model="Attrvalue4"
                  @change="selectSP5($event, catList5[3].group_name, 3)"
                >
                  <el-radio
                    v-for="item in catList5[3].spec_items"
                    :key="item.item_id"
                    :label="item.item_id"
                    :value="item.spec_value"
                    >{{ item.spec_value }}</el-radio
                  >
                </el-radio-group>
              </div>

              <div class="mr" v-if="catList5.length >= 5">
                {{ catList5[4].group_name }} :
                <el-radio-group
                  v-model="Attrvalue5"
                  @change="selectSP5($event, catList5[4].group_name, 4)"
                >
                  <el-radio
                    v-for="item in catList5[4].spec_items"
                    :key="item.item_id"
                    :label="item.item_id"
                    :value="item.spec_value"
                    >{{ item.spec_value }}</el-radio
                  >
                </el-radio-group>
              </div>
              <div class="mr" v-if="catList5.length >= 6">
                {{ catList5[5].group_name }} :
                <el-radio-group
                  v-model="Attrvalue6"
                  @change="
                    selectSP5($event, catList5[5].group_name, 5, catList5[5])
                  "
                >
                  <el-radio
                    v-for="item in catList5[5].spec_items"
                    :key="item.item_id"
                    :label="item.item_id"
                    :value="item.spec_value"
                    >{{ item.spec_value }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>

            <div>
              <table border class="zhangdantable">
                <tr>
                  <th>期数</th>
                  <th>应还款(元)</th>
                </tr>
                <tr v-for="item in BillPrice" :key="item.index">
                  <td>{{ item.qishu }}</td>
                  <td>{{ item.jiage }}</td>
                </tr>
              </table>
            </div>
          </div>
          <div style="margin-top: 10px">
            <el-button type="primary" @click="xgspqd()">确 定</el-button>
            <el-button @click="dialogVisiblexgsp = false">取 消</el-button>
          </div>
        </div>
      </el-dialog> -->
      <el-dialog title="修改商品" :visible.sync="dialogVisiblexgsp" width="70%" @close="closexg">
        <div style="padding: 20px">
          <div style="
              margin: 20px 30px;
              border-radius: 20px;
              font-size: 25px;
              color: red;
              background-color: #e1e1e1;
              text-align: center;
              padding: 15px;
            ">
            如果需要修改订单商品信息，请务必与客户沟通好后进行修改，切记不可私自修改!每次修改都会详细记录!
          </div>

          <div style="
              margin: 20px 30px;
              border-radius: 20px;
              font-size: 25px;
              color: #2f96db;
              background-color: #e1e1e1;
              text-align: center;
              padding: 15px;
            ">
            收货人： {{ shr }} <br />
            电话： {{ shrdh }} <br />
            原商品名称: {{ prData.product_name }} <br />
            原商品规格：{{ prData.product_attr }} <br />
          </div>

          <div style="display: flex">
            <div style="display: flex; flex-direction: column">
              <div class="mr">
                商品名称：
                <el-select v-model="sxggvalue" placeholder="请选择" @change="selectSP3($event)" size="100%">
                  <el-option v-for="item in catList3" :key="item.product_id" :label="item.product_name"
                    :value="item.product_id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div style="display: flex; flex-direction: column">
              <div class="mr" v-if="catList5.length >= 1">
                {{ catList5[0].group_name }} :
                <!-- {{ JSON.stringify(Attrvalue2) || "1" }} -->
                <el-radio-group v-model="Attrvalue" @change="
                  selectSP5(
                    $event,
                    catList5[0].group_name,
                    0,
                    catList5[0].spec_items
                  )
                  ">
                  <el-radio v-for="item in catList5[0].spec_items" :key="item.item_id" :label="item.item_id"
                    :value="item.spec_value">{{ item.spec_value }}</el-radio>
                </el-radio-group>
              </div>
              <div class="mr" v-if="catList5.length >= 2">
                {{ catList5[1].group_name }} :
                <!-- {{ JSON.stringify(Attrvalue2) || "1" }} -->
                <el-radio-group v-model="Attrvalue2" @change="
                  selectSP5(
                    $event,
                    catList5[1].group_name,
                    1,
                    catList5[1].spec_items
                  )
                  ">
                  <el-radio v-for="item in catList5[1].spec_items" :key="item.item_id" :label="item.item_id"
                    :value="item.spec_value">{{ item.spec_value }}</el-radio>
                </el-radio-group>
              </div>
              <div class="mr" v-if="catList5.length >= 3">
                {{ catList5[2].group_name }} :
                <el-radio-group v-model="Attrvalue3" @change="
                  selectSP5(
                    $event,
                    catList5[2].group_name,
                    2,
                    catList5[2].spec_items
                  )
                  ">
                  <el-radio v-for="item in catList5[2].spec_items" :key="item.item_id" :label="item.item_id"
                    :value="item.spec_value">{{ item.spec_value }}</el-radio>
                </el-radio-group>
              </div>
              <div class="mr" v-if="catList5.length >= 4">
                {{ catList5[3].group_name }} :
                <el-radio-group v-model="Attrvalue4" @change="
                  selectSP5(
                    $event,
                    catList5[3].group_name,
                    3,
                    catList5[3].spec_items
                  )
                  ">
                  <el-radio v-for="item in catList5[3].spec_items" :key="item.item_id" :label="item.item_id"
                    :value="item.spec_value">{{ item.spec_value }}</el-radio>
                </el-radio-group>
              </div>

              <div class="mr" v-if="catList5.length >= 5">
                {{ catList5[4].group_name }} :
                <el-radio-group v-model="Attrvalue5" @change="
                  selectSP5(
                    $event,
                    catList5[4].group_name,
                    4,
                    catList5[4].spec_items
                  )
                  ">
                  <el-radio v-for="item in catList5[4].spec_items" :key="item.item_id" :label="item.item_id"
                    :value="item.spec_value">{{ item.spec_value }}</el-radio>
                </el-radio-group>
              </div>
              <div class="mr" v-if="catList5.length >= 6">
                {{ catList5[5].group_name }} :
                <el-radio-group v-model="Attrvalue6" @change="
                  selectSP5(
                    $event,
                    catList5[5].group_name,
                    5,
                    catList5[5].spec_items
                  )
                  ">
                  <el-radio v-for="item in catList5[5].spec_items" :key="item.item_id" :label="item.item_id"
                    :value="item.spec_value">{{ item.spec_value }}</el-radio>
                </el-radio-group>
              </div>
            </div>
            <!-- <div style="display: flex; flex-direction: column">
              <div style="margin: 20px 30px;">
                <span class="qianshu">总租金</span>:<el-input
                  style="width: 50%; margin-left: 10px"
                  v-model="total_price"
                  @blur="handleBlur"
                  placeholder="请输入总租金"
                  disabled
                ></el-input>
              </div>
              <div style="margin: 20px 30px;">
                <span class="qianshu">每期租金</span>:
                <div class="d-c-c" style="width: 30%">
                  <table border class="zhangdantable">
                    <tr>
                      <th>期数</th>
                      <th>应还款(元)</th>
                    </tr>
                    <tr v-for="item in BillPrice" :key="item.index">
                      <td>{{ item.qishu }}</td>
                      <td>
                        <el-input
                          v-model="item.jiage"
                          placeholder="请输入内容"
                           @input="handleBlur1"
                        ></el-input>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div> -->
          </div>
          <div style="margin-top: 10px">
            <el-button type="primary" @click="xgspqd()">确 定</el-button>
            <el-button @click="dialogVisiblexgsp = false">取 消</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 订单发货弹窗 -->
      <el-dialog title="物流信息" :visible.sync="dialogVisiblewlfh" width="600px">
        <el-tabs v-model="is_delivery" @tab-click="fahuoClick">
          <el-tab-pane label="去发货" :name="10">
            <el-form size="small" ref="form" :model="form" label-position="right" label-width="100px">
              <el-form-item label="物流公司：">
                <el-select v-model="form.express_id" placeholder="请选择快递公司" style="width: 100%">
                  <el-option :label="item.express_name" v-for="(item, index) in expressList" :key="index"
                    :value="item.express_id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="物流单号：">
                <el-input v-model="form.express_no" class="max-w460"></el-input>
              </el-form-item>
              <el-form-item label="设备编号：">
                <el-input v-model="form.equipment_no" class="max-w460"></el-input>
              </el-form-item>
              <el-form-item label="归还地址：">
                <el-input v-model="form.return_address" class="max-w460"></el-input>
              </el-form-item>
              <el-form-item label="归还联系人：">
                <el-input v-model="form.return_contact" class="max-w460"></el-input>
              </el-form-item>
              <el-form-item label="发货金额：">
                <el-input v-model="form.principal" class="max-w460"></el-input>
              </el-form-item>
            </el-form>
            <div style="margin-top: 10px" class="d-e-c d-r">
              <el-button @click="orderqd()" type="primary">确 定</el-button>
              <el-button @click="dialogVisiblewlfh = false">取 消</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="线下发货" :name="20">
            <div class="image-upload-container">
              <el-upload class="avatar-uploader" ref="upload" action="string"
                accept="image/jpeg,image/png,image/jpg,image/gif" :before-upload="onBeforeUploadImage"
                :http-request="expressImageUpload" :show-file-list="false" :on-change="fileChange" :limit="1">
                <div v-if="imageUrl" class="image-preview-wrapper">
                  <img :src="imageUrl" class="avatar" />
                  <div class="image-actions-center">
                    <el-button type="text" size="small" @click.stop="previewImage">
                      <i class="el-icon-zoom-in"></i>
                    </el-button>
                    <el-button type="text" size="small" @click.stop="deleteImage" style="color: #f56c6c;">
                      <i class="el-icon-delete"></i>
                    </el-button>
                  </div>
                </div>
                <i v-else class="el-icon-plus avatar-uploader-icon" style="border: 1px dashed #d9d9d9"></i>
              </el-upload>
            </div>
            <div style="margin-top: 10px" class="d-e-c d-r">
              <el-button @click="expressImageSumbit()" type="primary">确 定</el-button>
              <el-button @click="dialogVisiblewlfh = false">取 消</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>

      <!-- 操作备注弹框 -->
      <el-dialog title="操作备注" :visible.sync="dialogVisiblezcbz" width="30%">
        <span slot="footer" class="dialog-footer">
          <el-input v-model.trim="inputzcbz" placeholder="请输入内容"></el-input>
          <div style="margin-top: 10px">
            <el-button @click="zcbzqd()">确 定</el-button>
            <el-button @click="dialogVisiblezcbz = false">取 消</el-button>
          </div>
        </span>
      </el-dialog>

      <!-- 审核说明弹框 -->
      <el-dialog title="审核说明" :visible.sync="dialogVisibleshsm" width="30%">
        <span slot="footer" class="dialog-footer">
          <el-input v-model="inputshsm" type="textarea" :rows="2" placeholder="请输入内容"></el-input>
          <div style="margin-top: 10px">
            <el-button @click="shsmqd()">确 定</el-button>
            <el-button @click="dialogVisibleshsm = false">取 消</el-button>
          </div>
        </span>
      </el-dialog>

      <!-- 风控备注弹框 -->
      <el-dialog title="风控备注" :visible.sync="dialogVisiblefkbz" width="30%">
        <span slot="footer" class="dialog-footer">
          <el-input v-model="inputfkbz" placeholder="请输入内容"></el-input>
          <div style="margin-top: 10px">
            <el-button @click="fkbzqd()">确 定</el-button>
            <el-button @click="dialogVisiblefkbz = false">取 消</el-button>
          </div>
        </span>
      </el-dialog>

      <!-- 弹窗 -->
      <el-dialog title="三要素" :visible.sync="dialogTableVisible">
        <div style="margin-bottom: 10px">
          <el-input v-model="sysname" placeholder="请输入姓名"></el-input>
        </div>
        <div style="margin-bottom: 10px">
          <el-input v-model="syssfz" placeholder="请输入身份证"></el-input>
        </div>
        <div style="margin-bottom: 10px">
          <el-input v-model="syssjh" placeholder="请输入手机号"></el-input>
        </div>
        <el-button @click="sanyaoshuqd()" type="primary">确 定</el-button>
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <!-- <div class="sanyaosu"> {{sanyaosumsg}}</div>
            <div class="sanyaosu">姓名，身份证号，手机号{{ sanyaosu }}</div> -->
      </el-dialog>
      <!-- 提交租期 -->
      <el-dialog title="提交租期" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
        <el-checkbox-group v-model="shneheList">
          <el-checkbox v-for="item in zqlist" :label="item.bill_id" :key="item.bill_id"
            :disabled="item.is_pay_status == 1 ? true : false">{{ "第" + item.current_period + "期" }}
            {{ item.repayment_date | formatDate }} {{ item.price + "元" }}
          </el-checkbox>
        </el-checkbox-group>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="queding()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 预交租金 -->
      <el-dialog title="预交租金" :visible.sync="dialogVisible1" width="80%" :before-close="handleClose1">
        <div style="margin: 25px 0">
          <el-input v-model="yushou" type="textarea" placeholder="请输入金额"></el-input>
          <br />
        </div>
        <div style="margin: 25px 0">
          <h3 style="margin: 20px 0">碎屏险</h3>

          <el-radio-group v-model="radio">
            <el-radio disabled label="1">已选择</el-radio>
            <el-radio disabled label="2">未选择</el-radio>
          </el-radio-group>
        </div>
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="queding1()">确 定</el-button>
      </el-dialog>
      <!-- 风险查询 -->
      <el-dialog title="签署状态" :visible.sync="fengxianchaxun">
        <span class="qianshu">{{ fengxian }}</span>
      </el-dialog>
      <!-- 布尔征信弹窗 -->
      <el-dialog title="布尔征信" :visible.sync="dialogTableVisible1">
        <!-- <div class="sanyaosu"> {{sanyaosumsg}}</div> -->
      </el-dialog>
      <!-- 操作备注 -->
      <el-dialog title="操作备注" :visible.sync="dialogVisible4" width="60%" :before-close="handleClose4">
        <div style="margin: 25px 0">
          <el-input v-model="remarksText" placeholder="请输入"></el-input>
          <br />
        </div>
        <el-button @click="dialogVisible4 = false">取 消</el-button>
        <el-button type="primary" @click="queding4()">确 定</el-button>
      </el-dialog>
      <!-- 风控备注 -->
      <el-dialog title="风控备注" :visible.sync="dialogVisible5" width="60%" :before-close="handleClose5">
        <div style="margin: 25px 0">
          <el-input v-model="remarksText1" placeholder="请输入"></el-input>
          <br />
        </div>
        <el-button @click="dialogVisible5 = false">取 消</el-button>
        <el-button type="primary" @click="queding5()">确 定</el-button>
      </el-dialog>
      <!-- 首期金额-自主定价 -->
      <el-dialog title="自主定价" :visible.sync="apDialogVisible" width="600px">
        <div style="margin: 25px 0">
          <el-input v-model="auto_price" placeholder="请输入"></el-input>
        </div>
        <el-button @click="apDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editIssue()">确 定</el-button>
      </el-dialog>
      <!-- 去签署 -->
      <el-dialog title="签署详情" :visible.sync="dialogVisible2" width="60%" :before-close="handleClose2">
        <div style="height: 200px">
          <span style="margin: 5px">签署状态：</span>
          <div class="anniu" v-if="folwid">
            <div class="d1" v-if="htdata.data.data.signFlowStatus == '0'" @click="goshowurl()">
              草稿
            </div>
            <div class="d1" v-if="htdata.data.data.signFlowStatus == '1'" @click="goshowurl()">
              签署中
            </div>
            <div class="d1" v-if="htdata.data.data.signFlowStatus == '2'" @click="goshowurl()">
              完成
            </div>
            <div class="d1" v-if="htdata.data.data.signFlowStatus == '3'" @click="goshowurl()">
              撤销
            </div>
            <div class="d1" v-if="htdata.data.data.signFlowStatus == '5'" @click="goshowurl()">
              过期
            </div>
            <div class="d1" v-if="htdata.data.data.signFlowStatus == '7'" @click="goshowurl()">
              拒签
            </div>
            <div class="d1" v-if="folwid" @click="xiazai(folwid)">
              点击下载该合同
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 押金转租金 -->
      <el-dialog title="预授权资金转租金" :visible.sync="dialogVisible3" width="60%" :before-close="handleClose3">
        <div style="margin: 25px 0">
          <el-input v-model="zujin" placeholder="请输入金额"></el-input> <br />
        </div>
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="queding2()">确 定</el-button>
      </el-dialog>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-sizes="[10, 20, 50, 100]" :page-size="10"
          layout="total, prev,sizes ,pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
      <!-- 密码弹窗 -->
      <el-dialog title="请输入密码" :visible.sync="dialogVisible10" width="20%">
        <div style="height: 100px">
          <el-input placeholder="请输入密码" v-model="sdinput" show-password></el-input>
          <div style="margin-top: 20px; display: flex; justify-content: center">
            <el-button type="primary" @click="sdqd()">确定</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 收货确认 -->
      <el-dialog title="确认收货" :visible.sync="dialogVisibleGoods" width="30%">
        <el-dialog width="30%" title="信息不一致提醒" :visible.sync="innerVisible" append-to-body>
          <div>该订单（身份证/合同/人脸）未认证/通过是否提交确认收货</div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="innerVisible = false">取 消</el-button>
            <el-button type="primary" @click="determineGoods2()">确 定</el-button>
          </span>
        </el-dialog>
        <div>
          <div class="Goodstype">
            <div>身份证号核验:</div>
            <el-radio-group v-model="Goods1">
              <el-radio :label="1">一致</el-radio>
              <el-radio :label="0">不一致</el-radio>
            </el-radio-group>
          </div>
          <div class="Goodstype">
            <div>是否合同确认:</div>
            <el-radio-group v-model="Goods2">
              <el-radio :label="1">已确认</el-radio>
              <el-radio :label="0">未确认</el-radio>
            </el-radio-group>
          </div>

          <div class="Goodstype">
            <div>是否进行人脸核验:</div>
            <el-radio-group v-model="Goods3">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div></div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleGoods = false">取 消</el-button>
          <el-button type="primary" @click="determineGoods()">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 债券输入图片弹窗 -->
      <el-dialog title="请输入债权告知书" :visible.sync="showZqDialog" width="20%">
        <el-button @click="chooseImg('pdf', 'pdf')">选择图片(仅限pdf格式)</el-button>
        <div style="margin-top: 10px">
          <el-button @click="getbase()">确 定</el-button>
          <el-button @click="showZqDialog = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <Shen v-if="shenhe" :open_edit="shenhe" :order_id="order_id" @close="closeShenhe($event, 'edit')"></Shen>
    <Ju v-if="Ju" :open_edit="shenhe" :order_id="order_id" @close="closeShenhe2($event, 'edit')"></Ju>
    <Logistics :logisticsData="logisticsData" :isLogistics="isLogistics" @closeDialog="closeLogistics">
    </Logistics>
    <Fenpei v-if="fenpei" :fplist="fplist" :order_id="order_id" :dxlist="dxlist" @close="closeShenhe3($event, 'edit')">
    </Fenpei>
    <Merchant v-if="fpsh" :order_id="order_id" :dxlist="dxlist" @close="closeShenhe4($event, 'edit')"></Merchant>

    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" :config="config" @returnImgs="returnImgsFunc">
    </Upload>

    <!--上传pdf-->
    <PDF v-if="pdf" :order_id="order_id" :pdftype="pdftype" @close="closeShenhe5($event, 'edit')"></PDF>

    <!-- 生成交易快照 -->
    <ExportPDF v-if="ExportShow" :data="Exportdata" @close="closeExport($event)"></ExportPDF>
    <!-- 加入黑名单 -->
    <Blacklist v-if="BlackShow" :order_id="order_id" @close="closeHMD($event)"></Blacklist>

    <QrPayModel ref="qrPayRef"></QrPayModel>
    <el-dialog title="查询订单状态" :visible="isShowOrderStatus" width="35%" @close="isShowOrderStatus = false">
      <orderStatu :OrderStatusDetail="OrderStatusDetail" />
    </el-dialog>
    <el-dialog title="物流回执单" :visible="logisticsVisible" @close="logisticsVisible = false">
      <el-upload action="" list-type="picture-card" :accept="accept" :file-list="fileList" :on-remove="handleRemove"
        :http-request="UploadImage" :multiple="true">
        <i class="el-icon-plus"></i>
        <template #file="{ file }">
          <img :src="file.url" class="el-upload-list__item-thumbnail" />
          <span class="el-upload-list__item-actions">
            <span class="el-upload-list__item-preview" @click="handlePicturePreview(file)">
              <i class="el-icon-zoom-in"></i>
            </span>
            <span  class="el-upload-list__item-delete" @click="handleRemove(file)">
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </template>
      </el-upload>
      <el-button @click="logisticsSubmit">确定</el-button>
    </el-dialog>
    <el-dialog :visible.sync="previewImageVisible" width="40%" center>
      <img :src="previewImageUrl" style="width:100%" />
    </el-dialog>
    <el-dialog title="用户取消订单操作" :visible.sync="confirmVisble" width="35%" @close="confirmVisble = false">
      <el-form>
        <el-form-item label="是否同意">
          <el-radio-group v-model="confirmCancelStatus">
            <el-radio :label="true">同意</el-radio>
            <el-radio :label="false">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item style="display: flex; justify-content: flex-end;">
          <el-button type="primary" @click="confirmVisble = false">取消</el-button>
          <el-button type="primary" @click="confirmSumbit">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="免押退款处理" :visible="MianyaVisible" @close="MianyaVisible = false">
      <el-form label-position="right" label-width="120px">
        <el-form-item label="退款金额">
          <el-radio-group v-model="mianyaStatus">
            <el-radio :label="1">同意退款</el-radio>
            <el-radio :label="2">拒绝退款</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="MianyaRefundConfirm()">确 定</el-button>
          <el-button @click="MianyaVisible = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="pictureVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Shen from "./dialog/shenhe.vue";
import PDF from "./dialog/uploadPDF.vue";
import Ju from "./dialog/Ju.vue";
import Fenpei from "./dialog/fenpei.vue";
import Merchant from "./dialog/Merchant.vue";
import ExportPDF from "./dialog/ExportPDF.vue";
import Blacklist from "./dialog/blacklist.vue";
import OrderApi from "@/api/order.js";
import useApi from "@/api/useApi.js";
import FengkongApi from "@/api/fengkong.js";
import PorductApi from "@/api/product.js";
import Logistics from "@/components/logistics/viewLogistics.vue";
import qs from "qs";
import { number } from "echarts/lib/export";
import { indexOf, isArray } from "zrender/lib/core/util";
import orderStatu from "./dialog/orderStatus.vue";
import Upload from "@/components/file/Upload";
import QrPayModel from "./dialog/qrPayModel.vue";
import { isZG } from "@/config/platform.js";
import AntWithHold from "./dialog/AntWithHold/AntWithHold.vue";
// import eqbContract from "./dialog/AntWithHold/eqbContract.vue";
import SuperviseLock from "./dialog/superviseLock.vue";
import FileApi from "@/api/file.js";
import WeiPai from "./dialog/weipai/weipai.vue";

const machineTabs = [
  { label: "全部", name: "" },
  { label: "申请中", name: "0" },
  { label: "通过", name: "1" },
  { label: "拒绝", name: "2" }
];

const staticData = { machineTabs };

export default {
  components: {
    Logistics,
    Shen,
    Ju,
    Fenpei,
    Merchant,
    Upload,
    PDF,
    ExportPDF,
    Blacklist,
    QrPayModel,
    AntWithHold,
    // eqbContract,

    WeiPai,
    orderStatu,
    SuperviseLock
  },
  data() {
    return {
      apDialogVisible: false,
      auto_price: "",
      accept: "",
      logisticsVisible: false,
      is_zgzl: isZG(),
      newyushou: "",
      BillPrice: "",
      NumberOfPeriods: "",
      shouji_price: "",
      rate: "",
      linghuo_price: "", //灵活收款
      // 订单类型
      orderType: [
        {
          id: "0",
          name: "普通订单"
        },
        {
          id: "1",
          name: "以租代购"
        }
      ],
      Goods1: "",
      Goods2: "",
      Goods3: "",
      innerVisible: false, //收货信息不一致弹框
      dialogVisibleGoods: false,
      BlackShow: false, //显示黑名单弹框
      Exportdata: "",
      ExportShow: false, //显示交易快照弹框
      /*风控资料类型列表*/
      fkList: [
        {
          type: "身份证正面",
          value: "sfzpositive"
        },
        {
          type: "身份证反面",
          value: "sfzback"
        },
        {
          type: "委托担保申请书",
          value: "authorization_agreement"
        },
        {
          type: "租赁合同",
          value: "zlht"
        },
        {
          type: "商品接收确认书",
          value: "wlhz"
        },
        {
          type: "物权证明",
          value: "wqzm"
        },
        {
          type: "代偿证明",
          value: "dczm"
        },
        {
          type: "代偿通知书",
          value: "dctzs"
        },
        {
          type: "短信催缴截图",
          value: "dxcjjt"
        }
      ],
      zltype: "", //风控资料选择type
      pdftype: "",
      config: "",
      schzd: "",
      dxcj: "",
      wqzm: "",
      type: [],
      /*是否打开图片选择*/
      isupload: false,
      dxlist: "", //多选删除订单id
      tglist: [], //推广账号
      shlist: [], //商户账号
      lease_type: "",
      product_attrdata: "",
      sku_iddata: "",
      // 修改商品数据
      catList: "",
      catList2: "",
      catList3: "",
      catList4: "",
      catList5: [],
      spflvalue: "",
      sxspvalue: "",
      sxggvalue: "",
      spggvalue: "",
      Attrvalue: "",
      Attrvalue2: "",
      Attrvalue3: "",
      Attrvalue4: "",
      Attrvalue5: "",
      Attrvalue6: "",
      ggname: "",
      ggname2: "",
      ggname3: "",
      ggname4: "",
      ggname5: "",
      ggname6: "",
      qishu: "",
      // 修改商品展示
      shr: "",
      shrdh: "",
      prData: "",
      // 三要素
      sysname: "",
      syssjh: "",
      syssfz: "",
      fengxian: "",
      username: "",
      usernum: "",
      mobile: "",
      /*发货*/
      form: {
        /*订单ID*/
        express_id: 10001,
        /*订单号*/
        express_no: "",
        //设备编号
        equipment_no: "",
        /* 本金 */
        principal: ""
        // /* 归还地址 */
        // return_address: "",
        // /* 归还联系人 */
        // return_contact: "",
      },
      /*快递公司列表*/
      expressList: [],
      /*结清*/
      jqform: {
        /*结清金额*/
        value: "",
        /*结清类型*/
        type: ""
      },
      /*结清类型列表*/
      jieqingList: [
        {
          type: "正常 (0-30天)",
          value: 1
        },
        {
          type: "关注 (31-60天)",
          value: 2
        },
        {
          type: "次级(61-120天)",
          value: 3
        },
        {
          type: "可疑(121天-180天)",
          value: 4
        },
        {
          type: "损失 (180天以上)",
          value: 5
        }
      ],
      jieguo: "",
      inputshsm: "",
      dialogVisibleshsm: false,
      pdf: false, //pdf显示弹框
      shenhe: false,
      Ju: false,
      fenpei: false,
      fpsh: false,
      fplist: [],
      inputfkbz: "",
      dialogVisiblefkbz: false,
      inputzcbz: "",
      dialogVisiblezcbz: false,
      sanyaosu: "",
      sanyaosumsg: "",
      dialogTableVisible: false,
      dialogTableVisible1: false,
      fengxianchaxun: false,
      age: "",
      sdinput: "",
      zujin: "",
      shop_url: "",
      htdata: "",
      folwid: "", // 签署id
      radio: "", //碎屏险
      order_id: "", // order_id 订单id
      remarksText: "",
      remarksText1: "",
      yushou: "",
      /*显示弹框*/
      fengxain1: false,
      dialogVisiblewc: false,
      dialogVisiblejq: false,
      dialogVisiblexgsp: false,
      dialogVisiblewlfh: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible10: false,
      dialogVisibleHZD: false,
      dialogVisibleDXCJ: false,
      dialogVisibleWQZM: false,
      dialogVisibleupzl: false,
      // 租期id
      shneheList: [],
      fileList: [],
      // 租期列表
      zqlist: "",
      /*显示弹框*/
      dialogVisible: false,
      /*切换菜单*/
      activeName: "all",
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        search: "",
        order_no: "",
        style_id: "",
        create_time: "",
        tuiguang_id: "",
        remarks_operation: "",
        // 以租代购类型
        car_lease: "",

        // 机审筛选
        auto_review: ""
      },
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*时间*/
      create_time: "",
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0,
        cancel: 0,
        haveInHand: 0,
        buyOut: 0,
        Returning: 0,
        returned: 0,
        examine: 0,
        refuse: 0
      },
      isLogistics: false,
      logisticsData: {},
      // 上报信息
      productInfo: {
        //产品信息
        period: "", //总期数
        payTypeId: 1, //产品类型
        businessTypeId: 3, //担保方式
        interestRate: "0%" //月利率
      },
      orderInfo: {
        //订单信息
        contractNo: "", //合同号
        contractAmount: "", //合同金额
        openDate: "", //开户日期
        dueDate: "", //到期日期
        loanAmount: "", //放款金额
        applyDist: "110000", //业务发生发生地的行政区划代码
        contractUrl: "" //债权告知书图片或pdf的BASE64字符串
      },
      personalInfo: {
        //个人信息
        name: "", //姓名
        idNo: "", //身份证号
        sex: "", //性别
        phone: "", //手机号
        eduLevel: "", //学历
        eduDegree: "", //学位
        idAddress: "", //户籍详细地址
        idDist: "", //户籍行政区划代码
        empStatus: "", //就业情况
        residenceStatus: "", //居住情况
        residenceAddress: "", //详细居住地址
        residenceDist: "", //居住地行政区划代码
        residencePostcode: "", //居住地邮编
        marriageStatus: "" //婚姻状况
      },
      repayPlan: [], //还款计划
      // 生成还款计划参数
      repaydata: {
        period: "",
        amount: "",
        startDate: "",
        endDate: ""
      },
      user_id: "",
      // 展示债权告知书输入弹窗
      showZqDialog: false,
      file: "",
      ...staticData,
      isShowOrderStatus: false,
      OrderStatusDetail: {},
      isShowPayStatus: false,
      PayStatusDetail: {},
      wanchengPassword: "",
      this_config: {
        /*上传个数*/
        total: 1,
        file_type: "image"
      },
      logisticsImages: [],
      previewImageUrl: "",
      previewImageVisible: false,
      confirmVisble: false,
      confirmCancelStatus: false,
      mianyaStatus: 1,
      MianyaVisible: false,
      fahuoActiveName: "first",
      imageUrl: "",
      dialogImageUrl: "",
      pictureVisible: false,
      is_delivery:10
    };
  },
  inject: ["baseInfo"],
  created() {
    /*获取列表*/
    this.getData();
    // 获取分类
    this.getFenlei();
    // 获取角色
    this.gofenpei2();
  },
  mounted() {
    window.mobilecheck = this.mobilecheck;
  },
  methods: {
    fileChange(e) {
      console.log(e);
    },
    previewImage() {
      if (this.imageUrl) {
        this.dialogImageUrl = this.imageUrl;
        this.pictureVisible = true;
      }
    },
    onBeforeUploadImage(file) {
      return true;
    },
    expressImageUpload(param) {
      let self = this;
      const loading = this.$loading({
        lock: true,
        text: "图片上传中,请等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const formData = new FormData();
      formData.append("iFile", param.file);
      formData.append("group_id", self.activeType);
      formData.append("file_type", "image");
      FileApi.uploadFile(formData)
        .then((response) => {
          loading.close();
          // self.getData();
          // param.onSuccess(); // 上传成功的图片会显示绿色的对勾
          // 但是我们上传成功了图片， fileList 里面的值却没有改变，还好有on-change指令可以使用
          console.log(response, "response");
          self.imageUrl = response.data.file_path;
          // self.product_images.push(response.data.file_path);
        })
        .catch((response) => {
          loading.close();
          self.$message({
            message: "本次上传图片失败",
            type: "warning",
          });
          param.onError();
        });
    },
    fahuoClick() { },
    deleteImage() {
      this.$confirm('确定要删除这张图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.imageUrl = "";
        // 重置上传组件的文件列表
        this.$refs.upload.clearFiles();
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.pictureVisible = true;
    },
    expressImageSumbit() {
      let self = this;
      if (self.imageUrl == null) {
        this.$message.error("请上传图片");
        return;
      }
      let order_id = self.order_id;
      let param = {
        express_image: self.imageUrl,

        is_delivery: 20,
      };
      OrderApi.delivery(
        {
          param,
          order_id: order_id,
        },
        true
      )
        .then((data) => {
          self.loading = false;
          self.$message({
            message: "恭喜你，发货成功",
            type: "success",
          });
          self.form.imageUrl = "";
          self.getData();
          self.dialogVisiblewlfh = false;
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    submitConfirm(row) {
      this.$confirm("确定同意用户取消订单", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          OrderApi.confirmCancel({
            order_id: row.order_id,
            is_cancel: true
          }).then(res => {
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
        })
        .catch(() => {
          OrderApi.confirmCancel({
            order_id: row.order_id,
            is_cancel: false
          }).then(res => {
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
        });
    },
    MianyaRefundConfirm() {
      let self = this;
      OrderApi.mianyaRefund({
        order_id: self.order_id
      }).then(res => {
        self.$message({
          message: res.msg,
          type: "success"
        });
        self.MianyaVisible = false;
        self.getData();
      });
    },
    handleMianyaRefund(row) {
      console.log(row);
      this.MianyaVisible = true;
      this.order_id = row.order_id;
    },
    confirmSumbit() {
      OrderApi.confirmCancel({
        order_id: this.order_id,
        is_cancel: this.confirmCancelStatus
      }).then(res => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "操作成功"
          });
        }
        this.confirmVisble = false;
        this.getData();
      });
    },
    confirmCancel(row) {
      this.confirmVisble = true;
      this.order_id = row.order_id;
    },
    logisticsSubmit() {
      let self = this;
      self.logisticsImages = self.logisticsImages.length > 0  ? self.logisticsImages : ''
      OrderApi.reqeceiptImg({
        order_id: self.order_id,
        images: self.logisticsImages
      }).then(res => {
        if (res.code == 1) {
          self.$message({
            message: res.msg,
            type: "success"
          });
          self.getData();
          self.logisticsVisible = false;
        } else {
          self.$message.error(res.msg || "上传失败");
          self.logisticsVisible = false;
        }
      });
    },
    handlePictureCardPreview(file) {
      console.log(file);
    },
    handlePicturePreview(file) {
      this.previewImageUrl = file.url;
      this.previewImageVisible = true;
    },
    handleRemove(file, fileList) {
      let self = this;
      let removeFiter = ''
      self.fileList.forEach((item,index)=>{
        if(file.uid == item.uid){
          removeFiter = index
        }
      })
      this.fileList.splice(removeFiter,1)
      this.logisticsImages.splice(removeFiter,1)
    },
    UploadImage(param) {
      let self = this;
      const loading = this.$loading({
        lock: true,
        text: "图片上传中,请等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const formData = new FormData();
      formData.append("iFile", param.file);
      formData.append("group_id", self.activeType);
      formData.append("file_type", self.this_config.file_type);
      FileApi.uploadFile(formData)
        .then(response => {
          loading.close();
          // console.log(response.data);
          self.logisticsImages.push(response.data.file_path);
          param.onSuccess(response.data); // 上传成功的图片会显示绿色的对勾
          self.fileList = [...self.fileList, { name: param.file.name, url: response.data.file_path }];
          // 但是我们上传成功了图片， fileList 里面的值却没有改变，还好有on-change指令可以使用
        })
        .catch(response => {
          loading.close();
          self.$message({
            message: "本次上传图片失败",
            type: "warning"
          });
          param.onError();
        });
    },
    logisticsSnp(e) {
      this.order_id = e.order_id;
      this.fileList = [];
      this.logisticsImages = [];
      if (e.receipt_images && e.receipt_images.length > 2) {
        try {
          const images = JSON.parse(e.receipt_images);
          if (Array.isArray(images)) {
            this.fileList = images.map(img => ({
              name: img.substring(img.lastIndexOf("/") + 1),
              url: img
            }));
            this.logisticsImages = [...images];
          }
        } catch (error) {
          console.error("Error parsing receipt images:", error);
          this.fileList = [];
          this.logisticsImages = [];
        }
      }
      this.logisticsVisible = true;
    },
    Terminate(row, status) {
      let self = this;
      OrderApi.auditCancelWithholding(
        {
          order_id: row.order_id,
          status: status
        },
        true
      ).then(data => {
        if (data.code == 1 && status == 1) {
          self.$message({
            type: "success",
            message: "解约成功"
          });
        } else if (data.code == 1 && status == 0) {
          self.$message({
            type: "success",
            message: "拒绝解约成功"
          });
        }
        self.getData();
      });
    },
    noDeduction(e) {
      let self = this;
      self
        .$confirm("是否确认代扣解约？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          OrderApi.cancelSign(
            {
              order_id: e.order_id
            },
            true
          ).then(data => {
            if (res.code == 1) {
              self.$message({
                type: "success",
                message: res.msg
              });
            }
          });
        });
    },
    auditDeduction(e) {
      let self = this;
      self
        .$confirm("是否要同意此用户的签约代扣，同意后不可撤回", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          OrderApi.auditWithholding(
            {
              order_id: e.order_id
            },
            true
          ).then(() => {
            self.$message({
              type: "success",
              message: "操作成功"
            });
          });
        });
    },
    viewPayStatus(e) {
      let self = this;
      OrderApi.queryTrade({
        order_id: e.order_id
      }).then(res => {
        self.isShowPayStatus = true;
        self.PayStatusDetail = res.data;
      });
    },
    viewOrderStatus(e) {
      let self = this;
      OrderApi.queryOrder({
        order_id: e.order_id
      }).then(res => {
        if (res.code == 1) {
          self.isShowOrderStatus = true;
          self.OrderStatusDetail = res.data;
        }
      });
    },
    closeEqb() {
      this.getData();
    },
    // 同意归还
    async guihuan(val) {
      console.log("同意归还");
      let { order_id } = val;
      let data = {
        order_id,
        order_status: 1
      };
      let res = await OrderApi.ghReturn(data, true);
      if (res.msg == "成功")
        this.$message({
          type: "success",
          message: "操作成功"
        });
      this.getData();
    },
    // 拒绝归还
    async guihuan2(val) {
      console.log("拒绝归还");
      let { order_id } = val;
      let data = {
        order_id,
        order_status: 2
      };
      let res = await OrderApi.ghReturn(data, true);
      if (res.msg == "成功")
        this.$message({
          type: "success",
          message: "操作成功"
        });
      this.getData();
    },
    // 一键机审
    machineReview: function () {
      if (this.dxlist === "") return;

      const list = this.dxlist.split(",");
      list.pop();

      useApi().machineReview({ order: list });
    },
    getQRPayDetail(row) {
      const dom = this.$refs.qrPayRef;
      dom.init(row);
    },
    // 控制菜单折叠
    openTable(str) {
      if (str == "open") {
        this.isOpen = true;
      } else {
        this.isOpen = false;
      }
      this.$nextTick(() => {
        this.handleArr(this.tableData.data, this.isOpen);
      });
    },
    handleArr(arr, flag) {
      arr.forEach(i => {
        this.$refs.table.toggleRowExpansion(i, flag);
        if (i.children) {
          this.handleArr(i.children);
        }
      });
    },
    // 赋强公证
    getProve(row) {
      let data = {
        orderId: row.order_id,
        order_id: row.order_id
      };
      FengkongApi.createApply1(data, true).then(res => {
        console.log(res.data);
        if (res.data.errors) {
          this.$message({
            type: "error",
            message: res.data.errors
          });
        } else if (res.code) {
          this.$message({
            type: "success",
            message: "验证成功,等待客户核验~~~"
          });
        }
      });
    },
    // 二次确认收货
    determineGoods2() {
      console.log("不一致继续收货");
    },
    // 收货弹框确定
    determineGoods() {
      console.log(this.Goods1, this.Goods2, this.Goods3);
      if (this.Goods1 && this.Goods2 && this.Goods3) {
        console.log("一致");
      } else {
        this.innerVisible = true;
      }
    },
    // 关闭黑名单弹窗
    closeHMD(e) {
      this.BlackShow = e.openDialog;
      this.getData();
    },
    // 加入黑名单
    addBlack(val) {
      this.order_id = val.order_id;
      this.BlackShow = true;
    },
    //关闭交易快照弹框
    closeExport(e) {
      this.ExportShow = e.openDialog;
      this.getData();
    },
    // 生成交易快照
    snapshot(val) {
      this.ExportShow = true;
      this.Exportdata = val;
    },
    /*上传pdf显示*/
    Uploadpdf(val, type) {
      this.order_id = val.order_id;
      this.pdf = true;
      if (type == "1") {
        this.pdftype = type;
      } else if (type == "2") {
        this.pdftype = type;
      }
    },
    /*选择图片*/
    chooseImg(file_type, file_name) {
      this.file_name = file_name;
      this.isupload = true;
      this.type = file_type;
      if (file_type == "pdf" && file_name == "pdf") {
        this.config = {
          total: 1,
          file_type: "pdf"
        };
      }
    },
    /*关闭选择图片*/
    returnImgsFunc(e) {
      this.isupload = false;
      if (e != null && e.length > 0) {
        if (this.type == "schzd") {
          this.schzd = e[0].file_path;
        } else if (this.type == "dxcj") {
          this.dxcj = e[0].file_path;
        } else if (this.type == "wqzm") {
          this.wqzm = e[0].file_path;
        } else if (this.type == "pdf") {
          this.file = e[0].file_path;
        }
      }
    },
    //上传回执单
    Uploadhzd(val) {
      this.schzd = val.wlhz;
      this.dialogVisibleHZD = true;
      this.order_id = val.order_id;
      this.config = { total: 3 };
    },
    //回执单确认
    qrUploadhzd() {
      let data = {
        order_id: this.order_id,
        wlhz: this.schzd
      };
      OrderApi.upwlhz(data, true)
        .then(res => {
          this.$message({
            type: "success",
            message: "上传成功"
          });
          this.getData();
          this.dialogVisibleHZD = false;
          this.schzd = "";
        })
        .catch(error => { });
    },
    //上传短信催缴截图
    Updxcjjt(val) {
      this.dxcj = val.dxcjjt;
      this.dialogVisibleDXCJ = true;
      this.order_id = val.order_id;
      this.config = { total: 3 };
    },
    //短信催缴截图确认
    qrUploaddxck() {
      console.log(this.dxcj, this.order_id);
      let data = {
        order_id: this.order_id,
        dxcjjt: this.dxcj
      };
      OrderApi.updxcjjt(data, true)
        .then(res => {
          this.$message({
            type: "success",
            message: "上传成功"
          });
          this.getData();
          this.dialogVisibleDXCJ = false;
          this.dxcj = "";
        })
        .catch(error => { });
    },
    //上传物权证明
    Upwqzm(val) {
      this.dxcj = val.dxcjjt;
      this.dialogVisibleWQZM = true;
      this.order_id = val.order_id;
      this.config = { total: 3 };
    },
    //物权证明确认
    qrUploadwqzm() {
      console.log(this.wqzm, this.order_id);
      let data = {
        order_id: this.order_id,
        wqzm: this.wqzm
      };
      OrderApi.upwqzm(data, true)
        .then(res => {
          this.$message({
            type: "success",
            message: "上传成功"
          });
          this.getData();
          this.dialogVisibleWQZM = false;
          this.wqzm = "";
        })
        .catch(error => { });
    },

    // 上传资料
    Upzl(val) {
      this.order_id = val.order_id;
      this.dialogVisibleupzl = true;
    },
    // 上传资料确认
    qrUpzl() {
      let data = {
        order_id: this.order_id,
        type: this.zltype
      };
      FengkongApi.upzl(data, true)
        .then(res => {
          this.$message({
            type: "success",
            message: "操作成功"
          });
          this.getData();
          this.dialogVisibleupzl = false;
        })
        .catch(error => { });
    },

    // 多选删除
    godeleteall() {
      this.$confirm("确定要删除选中的订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info "
      })
        .then(() => {
          // console.log("确定",this.dxlist);
          let data = {
            order_id: this.dxlist
          };
          OrderApi.deleteall(data, true)
            .then(res => {
              this.$message({
                type: "success",
                message: "删除成功"
              });
              this.getData();
            })
            .catch(error => { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 多选选中
    handleSelectionChange(val) {
      // console.log(val);
      let dxlist = "";
      for (let dxdata of val) {
        // if (dxdata.order_id != undefined) {
        dxlist += dxdata.order_id + ",";
        // }
      }
      // console.log(dxlist);
      this.dxlist = dxlist;
    },
    /* 推广信息*/
    gofenpei2() {
      // OrderApi.getalllist(
      //   {
      //     role_id: 4,
      //     page: 1,
      //     list_rows: 100
      //   },
      //   true
      // ).then(data => {
      //   this.tglist = data.data.list;
      // });
    },
    // 刷新订单
    getshuax() {
      this.getData();
      this.$message({
        message: "刷新订单成功",
        type: "success"
      });
    },
    // 筛选风控手机号
    remarksSj(str) {
      // console.log("筛选风控手机号",str);
      let newStr = str; //返回值
      const phoneReg = /(1[0-9]{2,10})|([0-9]{3,4})?[0-9]{7,8}|[\d\w]+\b@[a-zA-ZA-z0-9]+.[a-z]+/g; //匹配手机号或者固话,邮箱
      const num = str.replace(/\s|[(]|[)]|[(]|[)]|[-]*/g, ""); //去除字符串中所有空格、小括号和横杠
      const phone = num.match(phoneReg); //识别手机号或者固话（在字符串内检索指定的值，或找到一个或多个正则表达式的匹配）
      if (isArray(phone)) {
        phone.forEach(mobile => {
          // console.log(mobile)
          var newmobile =
            '<a onclick="mobilecheck(' + mobile + ')">' + mobile + "</a><br/>"; //现将筛选出来的手机号加上点击事件
          newStr = newStr.replace(mobile, newmobile); //查找当前手机号 将手机号替换成 有点击事件的手机号
        });
      }
      return newStr;
      // phone && (newStr = phone.join(','));//有值的话得到一个数组，用空格隔开转化为字符串
      // return newStr
    },
    // 点击亲属手机号
    mobilecheck(mobile) {
      let Params = { mobile: mobile };
      OrderApi.searchMobile(Params, true)
        .then(data => {
          console.log("成功返回的data", data);
          this.$message({
            message: data.msg,
            type: "success"
          });
        })
        .catch(error => { });
    },
    // 下载e签宝合同
    xiazai(url) {
      let self = this;
      const eqbUrl = new URL(url)
      const urlParams = eqbUrl.searchParams
      const flowid =   urlParams.get('flowId')
      let Params = {
        flowid: flowid,
      };
      OrderApi.xiazai2(Params, true)
        .then((data) => {
          window.open(data.data.data.data.files[0].downloadUrl, "_blank");
        })
        .catch((error) => { });
    },
    // 关闭弹窗
    closeShenhe(e, f) {
      if (f == "edit") {
        this.shenhe = e.openDialog;
        this.getData();
      }
    },
    closeShenhe2(e, f) {
      if (f == "edit") {
        this.Ju = e.openDialog;
        this.getData();
      }
    },
    closeShenhe3(e, f) {
      if (f == "edit") {
        this.fenpei = e.openDialog;
        this.getData();
      }
    },
    closeShenhe4(e, f) {
      if (f == "edit") {
        this.fpsh = e.openDialog;
        this.getData();
      }
    },
    // pdf弹框
    closeShenhe5(e, f) {
      if (f == "edit") {
        this.pdf = e.openDialog;
        this.getData();
      }
    },
    //拒绝
    showShenhe(data) {
      this.order_id = data.order_id;
      this.shenhe = true;
    },
    //提交审核
    showShenhe2(data) {
      this.order_id = data.order_id;
      this.Ju = true;
    },
    //分控备注确定
    fkbzqd() {
      let Params = {
        order_id: this.order_id,
        remarksType: 2,
        remarksText: this.inputfkbz
      };
      OrderApi.orderRemarks(Params, true).then(res => {
        this.dialogVisiblefkbz = false;
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.getData();
      });
    },
    // 审核说明确定
    shsmqd() {
      let Params = {
        order_id: this.order_id,
        tuizu: this.inputshsm
      };
      OrderApi.ysunfreeze(Params, true).then(res => {
        this.dialogVisibleshsm = false;
        this.getData();
        this.$message({
          message: "操作成功",
          type: "success"
        });
      });
    },
    //操作备注确定
    zcbzqd() {
      let Params = {
        order_id: this.order_id,
        remarksType: 1,
        remarksText: this.inputzcbz
      };
      OrderApi.orderRemarks(Params, true).then(res => {
        this.dialogVisiblezcbz = false;
        this.getData();
        this.$message({
          message: "操作成功",
          type: "success"
        });
      });
    },
    // 操作备注弹框
    czbztk(row) {
      this.dialogVisiblezcbz = true;
      this.order_id = row.order_id;
    },

    // 分控备注弹框
    fzbztk(row) {
      this.dialogVisiblefkbz = true;
      this.order_id = row.order_id;
    },
    // 三要素确定
    sanyaoshuqd() {
      console.log(this.sysname, this.syssjh, this.syssfz);
      let Params = {
        usernum: this.syssfz,
        username: this.sysname,
        mobile: this.syssjh
      };
      OrderApi.sanyao(Params, true)
        .then(res => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message:
                res.data.result.resp_msg +
                "," +
                "结果:" +
                res.data.result.resp_data.result_code_desc
            });
          } else {
            this.$message({
              type: "warning",
              message:
                res.data.result.resp_msg +
                "," +
                "结果:" +
                res.data.result.resp_data.result_code_desc
            });
          }
          // self.sanyaosumsg = res.data.result.resp_msg;
          // self.sanyaosu = res.data.result.resp_data.result_code_desc;
        })
        .catch(error => { });
    },
    // 三要素
    gohuankuan(row) {
      // console.log(row,"row");
      this.dialogTableVisible = true;
      // let self = this;
      // this.$confirm('确定要查看三要素吗?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'info '
      // }).then(() => {
      //   let Params = {
      //   usernum:row.user.usernum,
      //   username:row.user.username,
      //   mobile:row.user.mobile
      // }
      // OrderApi.sanyao(Params, true)
      //   .then(res => {

      //     self.sanyaosumsg = res.data.result.resp_msg;
      //     self.sanyaosu = res.data.result.resp_data.result_code_desc;
      //   })
      //   .catch(error => { });
      // }).catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '已取消'
      //   });
      // });
    },
    //征信对接
    zhengxin(row) {
      let self = this;
      self.dialogTableVisible1 = true;
      let Params = {
        orderid: row.order_id
      };
      OrderApi.zhengyin(Params, true)
        .then(res => {
          self.sanyaosu = res.data.result;
        })
        .catch(error => { });
    },
    handleClick() {
      alert("button click");
    },
    // 资金解冻
    gojiedong(row) {
      this.$confirm("确定要解冻?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      })
        .then(() => {
          let data = {
            order_id: row.order_id
          };
          console.log(row.deposit, row.zhuanzujin);
          if (row.deposit > 0) {
            data.tuizu = row.deposit;
          } else {
            data.tuizu = row.zhuanzujin;
          }
          OrderApi.ysunfreeze(data, true)
            .then(res => {
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.getData();
            })
            .catch(error => { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    /*押金转租金*/
    goyajin(row) {
      this.order_id = row.order_id;
      this.dialogVisible3 = true;
    },
    /*退押金*/
    gotyj(row) {
      this.dialogVisibleshsm = true;
      this.order_id = row.order_id;
    },
    /*删除订单*/
    godelete(row) {
      this.$confirm("确定要删除订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info "
      })
        .then(() => {
          let data = {
            order_id: row.order_id
          };
          OrderApi.delete(data, true)
            .then(res => {
              this.$message({
                type: "success",
                message: "删除成功"
              });
              this.getData();
            })
            .catch(error => { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 确定发货
    orderqd() {
      let self = this;
      let param = self.form;
      if (param.express_id == null) {
        this.$message.error("请选择物流公司");
        return;
      }
      if (param.express_no == "") {
        this.$message.error("请填写物流单号");
        return;
      }
      param.is_delivery = self.is_delivery
      let order_id = self.order_id;
      OrderApi.delivery(
        {
          param: param,
          order_id: order_id
        },
        true
      )
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，发货成功",
            type: "success"
          });
          self.form.express_no = "";
          self.form.equipment_no = "";
          self.getData();
          self.dialogVisiblewlfh = false;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 订单确认发货
    gofahuo(row) {
      let self = this;
      self.dialogVisiblewlfh = true;
      const params = row.order_id;
      self.order_id = row.order_id;
      OrderApi.orderdetail({ order_id: params }, true)
        .then(data => {
          self.expressList = data.data.expressList;
        })
        .catch(error => { });
    },
    //确定订单
    goque(row) {
      console.log(row,'-----------');
      // this.dialogVisibleGoods = true;
      // return
      // receiptOrder  这个接口是确认收货并退款
      this.$confirm("确定要完成收货该订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info "
      })
        .then(() => {
          let data = {
            order_id: row.order_id,
            user_id: row.user_id
          };
          OrderApi.receipt(data, true)
            .then(res => {
              this.$message({
                type: "success",
                message: "确认成功"
              });
              this.getData();
            })
            .catch(error => { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    /*风控报告*/
    gofenkon(row) {
      console.log(row, "row");
      this.$confirm("确定生成百融风控报告吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info "
      })
        .then(() => {
          if (row.risk == "") {
            let data = {
              risk_type: 2,
              user_id: row.user.user_id
            };
            FengkongApi.riskAdd(data, true)
              .then(res => {
                let data1 = {
                  risk_type: 1,
                  user_id: row.user.user_id
                };
                FengkongApi.riskAdd(data1, true)
                  .then(res => {
                    this.$message({
                      type: "success",
                      message: "生成成功，正在前往~~~"
                    });
                    this.$router.push({
                      path: "/fengkong/operation/detail",
                      query: {
                        uid: row.user.user_id
                      }
                    });
                  })
                  .catch(error => {
                    self.loading = false;
                  });
              })
              .catch(error => {
                self.loading = false;
              });
          } else {
            this.$router.push({
              path: "/fengkong/operation/detail",
              query: {
                uid: row.user.user_id
              }
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    /*签署蚂蚁链代扣*/
    gomayi(row) {
      this.$confirm("确定签署蚂蚁链代扣吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info "
      })
        .then(() => {
          let data = {
            order_id: row.order_id
          };
          FengkongApi.chuangjianhetong(data, true)
            .then(res => {
              this.$message({
                type: "success",
                message: "生成成功,请前往订单详情查看~~~"
              });
              // this.$router.push({
              //   path: '/fengkong/operation/detail',
              //   query: {
              //     uid: row.user.user_id
              //   }
              // })
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // e签宝合同
    goaiqian(row) {
      const params = {
        order_id: row.order_id,
        app_id: row.app_id
      };

      this.$confirm("确定签署e签宝合同吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          FengkongApi.createEqb(params, true).then(res =>
            this.$message.success("生成成功")
          );
        })
        .catch(() => this.$message.info("已取消"));
    },
    //打开合同
    gockaq(val) {
      window.open(val, "_blank");
    },
    //下载合同
    xiazaiht(val) {
      window.open("https://leniu.cn-feeling.com/" + val, "_blank");
    },
    //风险命中查询
    fxmzcx(row) {
      let username = row.username;
      let usernum = row.usernum;
      let mobile = row.user.mobile;
      let fengxian = "";
      this.fengxianchaxun = true;
      axios
        .post(
          "https://blacklist.jiulove.cn/api.php?key=474e6bb3e64d2e670744ab7fd1ee2e16&phone=" +
          mobile +
          "&idcard=" +
          usernum +
          "&realname=" +
          username,
          {}
        )
        .then(response => {
          if (response.url == "") {
            fengxian = "暂无命中";
          } else {
            fengxian = "命中";
          }
          this.fengxian = fengxian;
          return;
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          return;
          reject(error);
        });
    },

    /*预交租金确定*/
    queding1() {
      let Params = {
        order_id: this.order_id,
        yushou: this.yushou
      };
      OrderApi.yushou(Params, true).then(res => {
        this.dialogVisible1 = false;
        this.$message({
          message: "操作成功",
          type: "success"
        });
      });
    },
    /*押金转租金确定*/
    queding2() {
      let Params = {
        order_id: this.order_id,
        money: this.zujin
      };
      OrderApi.zhuanzujin(Params, true).then(res => {
        this.dialogVisible3 = false;
        this.$message({
          message: "操作成功",
          type: "success"
        });
      });
    },
    /*操作备注弹窗确定*/
    queding4() {
      let Params = {
        order_id: this.order_id,
        remarksType: 1,
        remarksText: this.remarksText
      };
      OrderApi.orderRemarks(Params, true).then(res => {
        this.dialogVisible4 = false;
        this.$message({
          message: "操作成功",
          type: "success"
        });
      });
    },
    /*风控备注弹窗确定*/
    queding5() {
      let self = this;
      let Params = {
        order_id: self.order_id,
        remarksType: 2,
        remarksText: self.remarksText1
      };
      OrderApi.orderRemarks(Params, true).then(res => {
        self.getData();
        self.dialogVisible5 = false;
        self.$message({
          message: "操作成功",
          type: "success"
        });
      });
    },
    /*预交租金*/
    goyujiao(row) {
      this.dialogVisible1 = true;
      this.order_id = row.order_id;
      var str = row.product[0].product_attr;
      if (str.indexOf("499") != -1) {
        this.radio = "1";
        console.log("已选择");
      } else {
        this.radio = "2";
        console.log("未选择");
      }
    },
    /*操作备注*/
    gocaozuo(row) {
      this.dialogVisible4 = true;
      this.order_id = row.order_id;
    },
    /*风控备注*/
    gofengkong(row) {
      this.dialogVisible5 = true;
      this.order_id = row.order_id;
    },
    /*提交租期*/
    gozujin(row) {
      this.dialogVisible = true;
      let Params = {
        order_id: row.order_id
      };
      OrderApi.billinfo(Params, true)
        .then(res => {
          console.log("res", res);
          this.zqlist = res.data.list;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    /*关闭确认*/
    handleClose() {
      this.dialogVisible = false;
    },
    /*关闭确认*/
    handleClose1() {
      this.dialogVisible1 = false;
    },
    handleClose2() {
      this.dialogVisible2 = false;
    },
    handleClose3() {
      this.dialogVisible3 = false;
    },
    handleClose4() {
      this.dialogVisible4 = false;
    },
    handleClose5() {
      this.dialogVisible5 = false;
    },
    /*手动扣款弹窗确定*/
    sdqd() {
      console.log(this.sdinput);
      OrderApi.checkpwd(
        {
          password: this.sdinput
        },
        true
      ).then(data => {
        console.log(data, "成功");
        if (data.msg == "操作成功") {
          this.dialogVisible10 = false;
          console.log(this.shneheList);
          if (this.shneheList.length <= 0) {
            this.$message({
              message: "请选择归还期数",
              type: "error"
            });
            return;
          }
          OrderApi.toExamine(
            {
              billid: this.shneheList
            },
            true
          ).then(data => {
            this.dialogVisible = false;
            console.log(data, "成功");
            this.$message({
              message: "操作成功",
              type: "success"
            });
          });
        } else {
          this.$message.error("操作失败");
        }
      });
    },
    queding() {
      this.dialogVisible10 = true;
    },
    // 申请上报
    submission(row) {
      console.log(row.order_id, "申请上报");
      this.$confirm("确定要申请上报?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info "
      })
        .then(() => {
          let Params = {
            orderid: row.order_id
          };
          OrderApi.testBooleanDemo(Params, true)
            .then(res => {
              this.getData();
              this.$message({
                message: "操作成功",
                type: "success"
              });
            })
            .catch(error => { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 放款报送
    Loan(row) {
      console.log(row.order_id, "放款报送");
      this.$confirm("确定要放款报送?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info "
      })
        .then(() => {
          let Params = {
            order_id: row.order_id
          };
          OrderApi.fkbs(Params, true)
            .then(res => {
              this.getData();
              this.$message({
                message: "操作成功",
                type: "success"
              });
            })
            .catch(error => { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    /*签订合同*/
    goheton(row) {
      this.$confirm("确定要生成合同?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info "
      })
        .then(() => {
          let Params = {
            order_id: row.order_id
          };
          OrderApi.contract(Params, true)
            .then(res => {
              this.getData();
              this.$message({
                message: "操作成功",
                type: "success"
              });
            })
            .catch(error => { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    //开户
    kaihu(row) {
      this.$confirm("确定要继续操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info "
      })
        .then(() => {
          let Params = {
            order_id: row.order_id,
            user_id: row.user_id
          };
          FengkongApi.open(Params, true)
            .then(res => {
              this.getData();
              this.$message({
                message: "操作成功",
                type: "success"
              });
            })
            .catch(error => { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 结清
    jieqing(row) {
      this.order_id = row.order_id;
      this.dialogVisiblejq = true;
    },
    // 完成
    wancheng(row) {
      console.log(row.order_id);
      this.order_id = row.order_id;
      this.dialogVisiblewc = true;
    },
    // 结清确定
    orderjq() {
      let Params = {
        order_id: this.order_id,
        money: this.jqform.value,
        type: this.jqform.type
      };
      OrderApi.jieqing(Params, true)
        .then(res => {
          this.getData();
          this.$message({
            message: "操作成功",
            type: "success"
          });
        })
        .catch(error => { });
    },
    // 完成确定
    orderwc() {
      let self = this;
      OrderApi.checkpwd({
        password: self.wanchengPassword
      }).then(res => {
        if (res.code == 1) {
          this.$confirm("确定要继续操作?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "info "
          })
            .then(() => {
              let Params = {
                order_id: this.order_id
              };
              OrderApi.wancheng(Params, true)
                .then(res => {
                  this.getData();
                  this.$message({
                    message: "操作成功",
                    type: "success"
                  });
                  this.dialogVisiblewc = false;
                })
                .catch(error => { });
            })
            .catch(() => {
              this.dialogVisiblewc = false;
              this.$message({
                type: "info",
                message: "已取消"
              });
            });
        }
      });
    },
    /*去签署*/
    goqianshu(row) {
      this.folwid = row.folwid;
      this.shop_url = row.shop_url;
      if (!row.folwid) {
        this.$message({
          message: "请先操作生成合同",
          type: "warning"
        });
      } else {
        this.dialogVisible2 = true;
        OrderApi.FlowDetail(
          {
            flowId: row.folwid
          },
          true
        ).then(data => {
          this.htdata = data;
          this.getData();
        });
      }
    },
    /*分配客户*/
    gofenpei(row) {
      if (typeof row === "string" && this.dxlist === "") {
        this.$message.warning("请选择订单");
        return;
      }
      this.fenpei = true;
      this.order_id = row.order_id;
      console.log(this.order_id, "this");
      OrderApi.authuser(
        {
          role_id: 8
        },
        true
      ).then(data => {
        this.fplist = data.data.list.data;
        console.log("data", this.fplist);
      });
    },
    /*分配商户*/
    gofpMerchant(row) {
      if (typeof row === "string" && this.dxlist === "") {
        this.$message.warning("请选择订单");
        return;
      }
      this.fpsh = true;
      this.order_id = row.order_id;
      log;
    },
    // 跳转合同链接
    goshowurl() {
      open(this.shop_url);
    },
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    // 获取分类
    getFenlei() {
      let self = this;
      PorductApi.catList({}, true)
        .then(data => {
          self.loading = false;
          self.catList = data.data.list;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      OrderApi.orderlist(Params, true)
        .then(res => {
          // let list = [];
          for (let i = 0; i < res.data.list.data.length; i++) {
            let pricezq = 0;
            let item = res.data.list.data[i];
            item.remarks_risk = self.remarksSj(item.remarks_risk); //筛选风控手机号
            if (item.remarks_risk == "") {
              item.remarks_risk = "风控备注：暂无";
            } else {
              item.remarks_risk = "风控备注：" + item.remarks_risk;
            }
            //退款信息
            if (item.yj_fail_msg == "" && item.ys_fail_msg == "") {
              if (
                item.order_status.value == "40" ||
                item.order_status.value == "20"
              ) {
                item.tuikuanzhauntai = "成功";
              } else {
                item.tuikuanzhauntai = "";
              }
            } else {
              item.tuikuanzhauntai = "失败";
            }

            let shield = item.ant_shield;
            if (shield == "") {
              item.ant_shield = "未生成";
            } else {
              let shield1 = JSON.parse(shield);
              item.ant_shield = shield1.models[0].score;
            }
            let ze = item.credit_report;
            if (ze == "") {
              item.credit_report = "未生成";
              item.cancel_remark = "未生成";
            } else {
              let ze1 = JSON.parse(ze);
              item.credit_report = ze1.resp_data.score_norm_explain;
              item.cancel_remark = ze1.resp_data.verify_recomment;
            }
            item.order_bill.forEach(data => {
              if (data.is_pay_status == 1) {
                pricezq = Number(pricezq) + Number(data.price);
              }
            });
            item.pricezq = pricezq.toFixed(2);
            let topitem = {
              order_no: item.order_no,
              create_time: item.create_time,
              order_source: item.order_source,
              order_source_text: item.order_source_text,
              is_top_row: true,
              order_status: item.order_status.value
            };

            if (item.is_yushou != 2) {
              item.yushou = 0;
            }
            var edeposit = item.deposit;
            var zhuanzujinData = item.zhuanzujin;
            var nbop = item.new_buy_out_price;
            if (item.auth_no == "") {
              edeposit = 0;
            }
            if (item.maiduan_no == "") {
              nbop = 0;
            }

            item.yujyj = (
              Number(item.yushou) +
              Number(edeposit) +
              Number(zhuanzujinData)
            ).toFixed(2);
            item.pricezq = pricezq.toFixed(2);
            item.yijiao = (
              Number(item.yujyj) +
              Number(pricezq) +
              Number(zhuanzujinData) +
              Number(nbop)
            ).toFixed(2);
            item.ysqyjze = (Number(zhuanzujinData) + Number(edeposit)).toFixed(
              2
            );
            item.total_price = (
              Number(item.total_price) -
              Number(item.deposit) -
              Number(zhuanzujinData)
            ).toFixed(2);

            let strdata = item.product[0].product_attr;
            // console.log(strdata.indexOf("租完即送"));
            if (strdata.indexOf("租完即送") != -1) {
              item.lease_type = "租完即送";
            } else {
              item.lease_type = "租完买断";
            }
          }
          // self.tableData.data = list;
          self.tableData = res.data.list;
          self.totalDataNumber = res.data.list.total;
          self.exStyle = res.data.ex_style;
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => { });
    },

    goeditsp(row) {
      // this.selectSP();
      // this.selectSP2();
      // this.selectSP3();
      // this.dialogVisiblexgsp = true;
      // // console.log(row);
      // this.order_id = row.order_id;
      // this.shrdh = row.user.mobile;
      // this.shr = row.user.username;
      // this.prData = row.product[0];
      // this.NumberOfPeriods = row.lease_time;
      // this.newyushou = row.newyushou;
      // let jiage =
      //   ((row.shouji_price * row.rate) / 100 - Number(this.newyushou)) /
      //   this.NumberOfPeriods;
      // let obj = [];
      // for (let index = 1; index <= this.NumberOfPeriods; index++) {
      //   obj.push({ qishu: index, jiage: jiage.toFixed(2) });
      // }
      // this.BillPrice = obj;
      // console.log(this.BillPrice, "this.BillPrice");

      console.log(row);
      this.total_price = row.total_price;
      const amountPerPhase =
        this.total_price / row.order_bill[0].Total_number_of_periods;
      this.rentperterm = amountPerPhase.toFixed(2); // 保留两位小数

      this.product_attr = row.product[0].product_attr;
      this.spec_sku_id = row.product[0].spec_sku_id;
      this.selectSP(row.product[0].product.category_id);
      this.selectSP2(row.product[0].product.category_id);
      this.selectSP3(row.product[0].product_id, "row");
      this.dialogVisiblexgsp = true;
      // // console.log(row);
      this.order_id = row.order_id;
      this.shrdh = row.user.mobile;
      this.shr = row.user.username;
      this.prData = row.product[0];
      // // console.log(this.prData, 'this.prData');
      this.NumberOfPeriods = row.lease_time;
      this.newyushou = row.newyushou;
      console.log(row.shouji_price, row.rate);
      let jiage = this.total_price / this.NumberOfPeriods;
      console.log(jiage, this.NumberOfPeriods, "------");
      let obj = [];
      for (let index = 1; index <= this.NumberOfPeriods; index++) {
        obj.push({ qishu: index, jiage: jiage.toFixed(2) });
      }
      console.log(obj, "obj");
      this.BillPrice = obj;
    },

    openEditIssue(row) {
      this.order_id = row.order_id;
      this.apDialogVisible = true;
    },

    async editIssue(row) {
      const param = {
        order_id: this.order_id,
        auto_price: this.auto_price
      };

      const { code, msg } = await useApi().editIssue(param);

      code === 1 && this.$message.success(msg);
      this.apDialogVisible = false;
    },

    selectSP(e) {
      // console.log("品牌", e);
      if (e) {
        this.spflvalue = e;
      } else {
        this.spflvalue = 11;
      }
      // console.log("spflvalue", this.spflvalue);
      for (let var1 of this.catList) {
        if (var1.category_id == this.spflvalue) {
          this.catList2 = var1.child;
          // console.log(this.catList2, 'catList2');
        }
      }
    },

    selectSP2(e) {
      // console.log("e", e);
      if (e) {
        this.sxspvalue = e;
      } else {
        this.sxspvalue = 60;
      }
      // console.log("sxspvalue", this.sxspvalue);
      let self = this;
      PorductApi.productList(
        {
          category_id: this.sxspvalue,
          page: 1,
          list_rows: 100
        },
        true
      )
        .then(data => {
          self.loading = false;
          self.catList3 = data.data.list.data;
          // console.log(self.catList3, 'self.catList3');
        })
        .catch(error => {
          self.loading = false;
        });
    },
    selectSP3(e, type) {
      // console.log("selectSP3", e, this.product_attr);
      if (e) {
        this.sxggvalue = e;
      } else {
        this.sxggvalue = 308;
      }
      // console.log("sxggvalue", this.sxggvalue);
      let self = this;
      PorductApi.getEditData(
        {
          product_id: this.sxggvalue
        },
        true
      )
        .then(res => {
          console.log(res);
          this.sku_id_arr = res.data.model.sku;
          // console.log(res, "kkkk");
          // this.catList4 = res.data.model.sku;
          this.catList5 = res.data.specData.spec_attr;
          // console.log(this.catList5);
          if (type == undefined) {
            // Attrvalue
            // catList5[0].spec_items
            this.product_attr = "";
            this.catList5.forEach((item, index) => {
              if (item.group_name && item.group_name.includes("期")) {
                this.zhouqi = item.spec_items[0].spec_value;
              }
              if (item.spec_items && item.spec_items.length > 0) {
                const firstItem = item.spec_items[0];
                this.product_attr += `${item.group_name}:${firstItem.spec_value}; `;
              }
              switch (index) {
                case 0:
                  this.Attrvalue = item.spec_items[0].item_id;
                  break;
                case 1:
                  this.Attrvalue2 = item.spec_items[0].item_id;
                  break;
                case 2:
                  this.Attrvalue3 = item.spec_items[0].item_id;
                  break;
                case 3:
                  this.Attrvalue4 = item.spec_items[0].item_id;
                  break;
                case 4:
                  this.Attrvalue5 = item.spec_items[0].item_id;
                  break;
                // case 5:
                //   this.Attrvalue6 = item.spec_items[0].item_id;
                //   break;
              }
            });
            this.norm =
              this.Attrvalue +
              "_" +
              this.Attrvalue2 +
              "_" +
              this.Attrvalue3 +
              "_" +
              this.Attrvalue4 +
              "_" +
              this.Attrvalue5;
            // "_" +
            // this.Attrvalue6;
            let matchedItem = this.sku_id_arr.find(
              item => item.spec_sku_id === this.norm
            );
            console.log(matchedItem, "matchedItem,matchedItem", this.norm);
            let linePrice = matchedItem ? matchedItem.line_price : undefined;
            this.total_price = linePrice;
            let amountPerPhase = this.total_price / this.zhouqi;
            this.rentperterm = amountPerPhase.toFixed(2); // 保留两位小数
            // this.BillPrice
            this.BillPrice = [];

            for (let i = 0; i < Number(this.zhouqi); i++) {
              let obj = {
                qishu: i + 1,
                jiage: this.rentperterm
              };
              this.BillPrice.push(obj);
            }
            console.log(
              this.BillPrice,
              "this.BillPricethis.BillPricethis.BillPricethis.BillPrice"
            );
          } else {
            this.skuIdsArray = this.spec_sku_id.split("_").map(Number);
            this.Attrvalue = this.skuIdsArray[0];
            this.Attrvalue2 = this.skuIdsArray[1];
            this.Attrvalue3 = this.skuIdsArray[2];
            this.Attrvalue4 = this.skuIdsArray[3];
            this.Attrvalue5 = this.skuIdsArray[4];
            this.Attrvalue6 = this.skuIdsArray[5];
            this.norm = this.spec_sku_id;
          }
          console.log(this.Attrvalue6, " this.Attrvalue6");
          let phase;
          this.catList5[5].spec_items.forEach(item => {
            if (item.item_id == this.Attrvalue6) {
              phase = parseInt(item.spec_value, 10); // 确保spec_value是整数，并转换为数字
            }
          });
          this.zhouqi = phase;
          console.log(this.zhouqi, " this.zhouqi");

          // this.BillPrice
          this.BillPrice = [];

          for (let i = 0; i < Number(this.zhouqi); i++) {
            console.log(i, " this.zhouqi");

            let obj = {
              qishu: i + 1,
              jiage: (this.total_price / this.zhouqi).toFixed(2)
            };
            this.BillPrice.push(obj);
          }
          console.log(
            this.BillPrice,
            " this.BillPrice this.BillPrice this.BillPrice this.BillPrice"
          );
        })
        .catch(error => {
          self.loading = false;
        });
    },
    selectSP4(e) {
      // console.log(e);
      this.spggvalue = e;
    },

    selectSP5(e, name, index, data) {
      console.log(e, name, index, data, this.norm, this.product_attr);
      let arr1, arr2;
      arr1 = this.norm.split("_").map(Number);
      arr2 = this.product_attr.split(";");
      console.log(this.product_attr);
      console.log(this.norm);
      arr1[index] = e;
      this.norm = arr1.join("_");
      let str = data.find(item => item.item_id == e).spec_value;
      arr2[index] = `${name}:${str}`;
      if (name && name.includes("期")) {
        this.zhouqi = str;
      }
      console.log(this.zhouqi);
      let matchedItem = this.sku_id_arr.find(
        item => item.spec_sku_id === this.norm
      );
      let linePrice = matchedItem ? matchedItem.line_price : undefined;
      this.total_price = linePrice;
      let amountPerPhase = this.total_price / this.zhouqi;
      this.rentperterm = amountPerPhase.toFixed(2); // 保留两位小数
      this.BillPrice = [];

      for (let i = 0; i < Number(this.zhouqi); i++) {
        let obj = {
          qishu: i + 1,
          jiage: this.rentperterm
        };
        this.BillPrice.push(obj);
      }
      this.product_attr = arr2.join(";");
      console.log(this.product_attr);
      console.log(this.norm);
    },
    handleBlur(event) {
      console.log(this.total_price);
      let phase;
      this.catList5[5].spec_items.forEach(item => {
        if (item.item_id == this.Attrvalue6) {
          phase = parseInt(item.spec_value, 10); // 确保spec_value是整数，并转换为数字
        }
      });
      if (isNaN(phase) || phase <= 0) {
        console.error("无效的期数");
        return;
      }
      const amountPerPhase = this.total_price / phase;
      this.rentperterm = amountPerPhase.toFixed(2); // 保留两位小数
      this.BillPrice = [];

      for (let i = 0; i < Number(this.zhouqi); i++) {
        let obj = {
          qishu: i + 1,
          jiage: this.rentperterm
        };
        this.BillPrice.push(obj);
      }
    },
    // total_price
    handleBlur1() {
      let arr = 0;
      this.BillPrice.forEach(item => {
        arr += Number(item.jiage);
      });
      console.log(arr);
      this.total_price = arr.toFixed(2);
    },
    // 修改商品--预览账单
    Preview() {
      var jiage = (this.shouji_price * this.rate) / 100 / this.NumberOfPeriods;
      let obj = [];
      for (let index = 1; index <= this.NumberOfPeriods; index++) {
        if (index == 1) {
          let data = (Number(jiage) + Number(this.linghuo_price)).toFixed(2);
          obj.push({ qishu: index, jiage: data });
        } else {
          // 利率                             -      第一期+利率的前                              / 剩下的期数
          let data2 =
            ((this.shouji_price * this.rate) / 100 -
              (Number(jiage) + Number(this.linghuo_price))) /
            (this.NumberOfPeriods - 1);
          obj.push({ qishu: index, jiage: data2.toFixed(2) });
        }
      }

      this.BillPrice = obj;
    },

    // 修改商品确定
    xgspqd() {
      let self = this;
      console.log(self.BillPrice);
      let pricedata = [];
      self.BillPrice.forEach(item => {
        pricedata.push(item.jiage);
      });
      //pricedata
      OrderApi.checkproduct(
        {
          order_id: self.order_id,
          product_id: self.sxggvalue, // 商品名称
          sku_id: self.norm,
          product_attr: self.product_attr,
          lease_type: 1
          // qishu: pricedata.length,
          // shouji_price: self.total_price,
          // pricedata: pricedata,
        },
        true
      )
        .then(data => {
          // location.reload();
          console.log(data);
          if (data.msg == "产品修改成功") {
            self.dialogVisiblexgsp = false;
            self.getData();
            self.closexg();
            self.$message({
              message: "操作成功",
              type: "success"
            });
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 修改关闭
    closexg() {
      this.order_id = "";
      this.sxggvalue = "";
      this.spflvalue = "";
      this.sxspvalue = "";
      this.sku_iddata = "";
      this.product_attrdata = "";
      this.lease_type = "";
      this.Attrvalue = "";
      this.Attrvalue2 = "";
      this.Attrvalue3 = "";
      this.Attrvalue4 = "";
      this.Attrvalue5 = "";
      this.Attrvalue6 = "";
      this.shouji_price = "";
      this.rate = "";
      this.linghuo_price = "";
    },

    /*订单详情*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      // self.$router.push({
      //   path: '/order/order/Detail',
      //   query: {
      //     order_id: params
      //   }
      // });
      let routeData = self.$router.resolve({
        path: "/order/order/Detail",
        query: {
          order_id: params
        }
      });
      window.open(routeData.href, "_blank");
    },
    getLogistics(row) {
      let self = this;
      let Params = {
        order_id: row.order_id
      };
      self.loading = true;
      OrderApi.queryLogistics(Params, true)
        .then(res => {
          self.logisticsData = res.data.express.list;
          self.loading = false;
          self.openLogistics();
        })
        .catch(error => {
          self.loading = false;
        });
    },
    openLogistics() {
      this.isLogistics = true;
    },
    closeLogistics() {
      this.isLogistics = false;
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function () {
      let baseUrl = window.location.protocol + "//" + window.location.host;
      window.location.href =
        baseUrl +
        "/index.php/shop/order.operate/export?" +
        qs.stringify(this.searchForm);
    },
    // 上报
    shangbao(row) {
      this.orderInfo.contractNo = row.order_no; //订单信息的合同号
      this.user_id = row.user_id; //用户id
      this.orderInfo.contractAmount = row.total_price * 100; //合同金额  单位分
      this.orderInfo.loanAmount = row.total_price * 100; //放款金额
      this.productInfo.period = row.lease_time; //产品信息  总期数
      this.repaydata.period = row.lease_time; // 还款计划参数  总期数
      this.repaydata.amount = row.total_price;
      if (row.lease_start_time && row.lease_end_time) {
        let start = row.lease_start_time;
        let end = row.lease_end_time;
        this.repaydata.startDate = this.getDataYMD(start);
        this.repaydata.endDate = this.getDataYMD(end);
        this.orderInfo.openDate = this.getDataYMD(start);
        this.orderInfo.dueDate = this.getDataYMD(end);
      } else {
        this.repaydata.startDate = row.opendate;
        this.repaydata.endDate = row.duedate;
        this.orderInfo.openDate = row.opendate;
        this.orderInfo.dueDate = row.duedate;
      }
      // 获取用户信息
      OrderApi.getUserInfo({
        user_id: this.user_id
      }).then(res1 => {
        this.personalInfo = res1.data;
        // 生成还款计划
        OrderApi.createRepayPlan({
          period: this.repaydata.period,
          amount: this.repaydata.amount,
          startDate: this.repaydata.startDate,
          endDate: this.repaydata.endDate
        }).then(res3 => {
          this.repayPlan = res3.data;
          // 打开债券弹出框
          this.showZqDialog = true;
        });
      });
    },
    // 时间戳转换年月日
    getDataYMD(time) {
      let time1 = time * 1000;
      let date = new Date(time1);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let strDate = Y + M + D;
      return strDate;
    },
    // 转base64
    getbase() {
      OrderApi.getBase({
        file: this.file
      }).then(res => {
        this.orderInfo.contractUrl = res.data;
        // 开户
        this.productInfo1 = JSON.stringify(Object.assign({}, this.productInfo));
        this.orderInfo1 = JSON.stringify(Object.assign({}, this.orderInfo));
        OrderApi.load({
          productInfo: this.productInfo1,
          orderInfo: this.orderInfo1,
          personalInfo: this.personalInfo,
          repayPlan: this.repayPlan
        }).then(res => {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.showZqDialog = false;
        });
      });
    }
  },
  filters: {
    delivery(e) {
      if (e == "10001") {
        return "顺丰快递";
      }
      if (e == "10002") {
        return "邮政国内";
      }
      if (e == "10003") {
        return "圆通速递";
      }
      if (e == "10004") {
        return "申通快递";
      }
      if (e == "10005") {
        return "韵达快递";
      }
      if (e == "10006") {
        return "百世快递";
      }
      if (e == "10007") {
        return "中通快递";
      }
      return "暂无";
    },
    // 过滤器
    formatDate(value) {
      let date = new Date(value * 1000);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; //年月日时分秒
    },
    // 身份证换算成年龄
    getsfz(iden) {
      if (iden == null) {
        return 0;
      }
      let val = iden.length;
      let myDate = new Date();
      let month = myDate.getMonth() + 1;
      let day = myDate.getDate();
      let age = 0;

      if (val === 18) {
        age = myDate.getFullYear() - iden.substring(6, 10) - 1;

        if (
          iden.substring(10, 12) < month ||
          (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)
        )
          age++;
      }
      if (val === 15) {
        age = myDate.getFullYear() - iden.substring(6, 8) - 1901;

        if (
          iden.substring(8, 10) < month ||
          (iden.substring(8, 10) == month && iden.substring(10, 12) <= day)
        )
          age++;
      }
      return age;
      // this.age = age;
    }
  }
};
</script>
<style lang="scss">
.el-dropdown-menu__item+.el-dropdown-menu__item {
  margin-top: 5px;
}

// 以租代购样式
.carBox {
  background-color: #5e8f78;
  color: white;
  padding: 2px 10px;
  width: 70px;
  text-align: center;
}

.el-table__expanded-cell {
  padding: 0 !important;
}

.control {
  padding: 10px 20px;
  display: flex;
  border-bottom: #ebeef5 solid 1px;

  &>div {
    margin-right: 10px;
  }
}

.Goodstype {
  display: flex;
  padding: 20px;

  div {
    margin: 0 10px;
  }
}

.dotg {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #18bc9c;
}

.bzfw {
  color: #3722c2;
  background: #ddd8ff;
  font-size: 12px;
  padding: 2px 10px;
}

.leasetype {
  background-color: #a894a6;
  color: white;
  padding: 2px 10px;
  width: 70px;
  text-align: center;
}

.fontwb {
  font-weight: bold;
}

.mr {
  margin: 20px 30px;
}

.fwbold {
  font-weight: bold;
  font-size: 13px;
}

.d1 {
  width: 100px;
  list-style: none;
  border: 1px solid #ffa49f;
  padding: 5px;
  background-color: #fff1f0;
  color: #f6363e;
  border-radius: 10px;
  text-align: center;
  margin: 25px 0;
}

.czbutton div {
  margin-bottom: 3px;
}

.anniu1 {
  margin-bottom: 3px;
}

.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.disf {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}

.xiegang {
  color: #18bc9c;
  margin: 0 5px;
}

.xxflex {
  display: flex;
}

.usercolor {
  color: #3498db;
  font-weight: bold;
}

.juz {
  white-space: normal;
  color: #3498db;
}

.juz2 {
  white-space: normal;
  color: #e74c3c;
}

.juz3 {
  white-space: normal;
  color: #f39c12;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown+.el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.sanyaosu {
  text-align: center;
  font-size: 20px;
  margin: 10px;
}

.qianshu {
  font-size: 20px;
  color: red;
}

.zhangdantable {
  border-collapse: collapse;
  width: 380px;
  text-align: center;

  tr {
    height: 30px;
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.image-upload-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.image-preview-wrapper {
  position: relative;
  display: inline-block;
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  overflow: hidden;

  .avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .image-actions-center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    gap: 8px;
    opacity: 0;
    transition: opacity 0.3s;
    z-index: 2;

    .el-button {
      color: #fff;
      background-color: rgba(0, 0, 0, 0.6);
      border: none;
      border-radius: 50%;
      width: 32px;
      height: 32px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background-color: rgba(0, 0, 0, 0.8);
        transform: scale(1.1);
      }

      i {
        font-size: 16px;
      }
    }
  }

  &:hover .image-actions-center {
    opacity: 1;
  }

  &:hover .avatar {
    filter: brightness(0.7);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/index.vue